/* sdkWebLocal.js from models */
var sdk = {};
var sdkLocal = sdk;

const node_env = process.env.APP_ENV || "development";
const INSIDE_K8S = process.env.INSIDE_K8S || false;

// La partie logger qui utilise un modèle qui sera créer dynamiquement plus tard
sdk.logger = {}

sdk.logger.log = async function (level, data) {
    if (typeof data === "string") {
        console.log(data);
    } else {
        console.log(JSON.stringify(data));
    }
    var log = {
        environnement: node_env,
        module: "next-7",
        message: data,
        level: level,
        time: Math.floor(Date.now() / 1000)
    }
    if (typeof sdk.models.Logger !== "undefined")
        sdk.models.Logger.create(log);
}

if (typeof window === "undefined" && typeof document === "undefined") {
    // Dans le cas d'un plantage complet de l'application
    process.on("unhandledRejection", (reason, promise) => {
        const message = reason.stack || JSON.stringify(reason);
        sdk.logger.log("error", "Unhandled Rejection at: " + message);
        console.log("Unhandled Rejection at:", reason.stack || reason);
    });
}

// La partie messenger
if (typeof window === "undefined" && typeof document === "undefined") {
sdk.messenger = {}

const amqplib = require('amqplib');

const env = process.env.APP_ENV || 'development';
if (env=="development") {
    var amqp_url = 'amqp://user:user@kube-1:32082';
} else  {
    var amqp_url = 'amqp://user:user@rabbitmq.liberium.svc.cluster.local:5672';
}
//console.log("amqp_url", amqp_url);

var channel, connection;

function do_connect() {
    const delay = (ms) => new Promise((resolve => setTimeout(resolve, ms)));

    const connectRabbitMq = () => amqplib.connect(amqp_url)
    .then((conn) => {
        connection = conn;
        conn.on('error', function (err) {
        if (err.message !== 'Connection closing') {
            console.error('[AMQP] conn error', err.message);
        }
        });

        conn.on('close', function () {
        console.error('[AMQP] reconnecting');
        connectRabbitMq();
        });
        return conn.createChannel();
    })
    .then(ch => {
        //console.log('[AMQP] Channel created');
        channel = ch;
    })
    .catch((error) => {
        console.error(error);
        console.log('[AMQP] reconnecting in 1s');
        return delay(1000).then(() => connectRabbitMq())
    });
    connectRabbitMq();
}
do_connect();

sdk.messenger.useQueue = async function (queueName, callback) {
    try {
        await channel.assertQueue(env + "-" + queueName);
        callback(true);
    } catch (error) {
        console.log(error);
        callback(false);
    }
}

sdk.messenger.sendMsg = async function (queueName, data, callback) {
    // send data to queue
    try {
        await channel.sendToQueue(env + "-" + queueName, Buffer.from(JSON.stringify(data)));
        if (typeof callback === "function") callback(true);
    } catch (error) {
        console.log(error);
        if (typeof callback === "function") callback(false);
    }
}

sdk.messenger.prefetch = async function (num) {
    channel.prefetch(num);
}

sdk.messenger.ack = async function (msg) {
    channel.ack(msg);
}

sdk.messenger.getMessage = async function (queue, callback) {
    channel.get(queue, data => {
        callback(data);
    });
}

sdk.messenger.listenMsg = async function (queueName, callback) {
    channel.consume(env + "-" + queueName, data => {
        //console.log(`${Buffer.from(data.content)}`);
        //channel.ack(data);
        try {
            var content = JSON.parse(Buffer.from(data.content));
            content.msg = data;
            callback(content);
        } catch (error) {
            console.log("rabbitmq error:", error);
            //callback(null); // N'envoie pas de callback, puisquil y a une erreure
        }
    })
}

} // Si on est dans un environnement nodejs pour messenger

// La partie models
sdk.models = {}

var model_url = "";
if (INSIDE_K8S) {
    model_url = node_env === "development" ? 'http://models-svc.models-prod.svc.cluster.local:3050/models' : 'http://models-svc.models-prod.svc.cluster.local:3050/models';
} else {
    model_url = node_env === "development" ? 'http://localhost:3050/models' : 'https://api.liberium.net/models';
}
//console.log(model_url);

sdk.models.models = {
    createModel: async (model) => {
        try {
            const response = await fetch(model_url + '/models', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(model),
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return await response.json();
        } catch (error) {
            return { message: error.message };
        }
    },
    getAllModels: async () => {
        try {
            const response = await fetch(model_url + '/models');
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return await response.json();
        } catch (error) {
            return { message: error.message };
        }
    },
    getOne: async (id) => {
        try {
            const response = await fetch(model_url + '/models/' + id);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return await response.json();
        } catch (error) {
            return { message: error.message };
        }
    },
    updateModel: async (id, model) => {
        try {
            const response = await fetch(model_url + `/${id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(model),
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return await response.json();
        } catch (error) {
            return { message: error.message };
        }
    },
    deleteModel: async (id) => {
        try {
            const response = await fetch(model_url + `/models/${id}`, {
                method: 'DELETE',
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return await response.json();
        } catch (error) {
            return { message: error.message };
        }
    },
    moveToProduction: async (id) => {
        try {
            const response = await fetch(model_url + `/models/${id}/moveToProduction`, {
                method: 'PUT',
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return await response.json();
        } catch (error) {
            return { message: error.message };
        }
    },
}

sdk.models.components = {
    async getComponents() {
      const response = await fetch(`${model_url}/components`);
      return await response.json();
    },
  
    async getComponentsUsed() {
      const response = await fetch(`${model_url}/components/used`);
      return await response.json();
    },
  
    async getComponent(id) {
      const response = await fetch(`${model_url}/components/${id}`);
      return await response.json();
    },
  
    async updateComponent(id, model) {
      const response = await fetch(`${model_url}/components/${id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(model),
      });
      return await response.json();
    },
  
    async createComponent(data) {
      const response = await fetch(`${model_url}/components`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });
      return await response.json();
    },
  
    async deleteComponent(id) {
      const response = await fetch(`${model_url}/components/${id}`, {
        method: "DELETE",
      });
      return await response.json();
    },
};

// History
sdk.models.history = {
    async getAllHistory() {
      const response = await fetch(`${model_url}/history`);
      return await response.json();
    },
  
    async getComponentHistory(componentId) {
      const response = await fetch(`${model_url}/history/component/${componentId}`);
      return await response.json();
    },
  
    async getHistoryById(id) {
      const response = await fetch(`${model_url}/history/${id}`);
      return await response.json();
    },
  
    async restoreFromHistory(id) {
      const response = await fetch(`${model_url}/history/restore/${id}`, {
        method: "POST",
      });
      return await response.json();
    },
  
    async deleteHistory(id) {
      const response = await fetch(`${model_url}/history/${id}`, {
        method: "DELETE",
      });
      return await response.json();
    },
};
var auth_url = 'http://auth-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.auth = {};

const auth_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.auth.create = async (model) => {
    return await auth_fetch(auth_url + '/models/auth', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.auth.getAll = async () => {
    return await auth_fetch(auth_url + '/models/auth');
};

sdk.models.auth.getOne = async (id) => {
    return await auth_fetch(auth_url + '/models/auth/' + id);
};

sdk.models.auth.update = async (id, model) => {
    return await auth_fetch(auth_url + '/models/auth/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.auth.delete = async (id) => {
    return await auth_fetch(auth_url + '/models/auth/' + id, {
        method: 'DELETE'
    });
};

sdk.models.auth.register = async (data) => {
    return await auth_fetch(auth_url + '/models/auth/register', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.auth.login = async (data) => {
    return await auth_fetch(auth_url + '/models/auth/login', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var auth_token_url = 'http://auth-token-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.auth_token = {};

const auth_token_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.auth_token.create = async (model) => {
    return await auth_token_fetch(auth_token_url + '/models/auth_token', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.auth_token.getAll = async () => {
    return await auth_token_fetch(auth_token_url + '/models/auth_token');
};

sdk.models.auth_token.getOne = async (id) => {
    return await auth_token_fetch(auth_token_url + '/models/auth_token/' + id);
};

sdk.models.auth_token.update = async (id, model) => {
    return await auth_token_fetch(auth_token_url + '/models/auth_token/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.auth_token.delete = async (id) => {
    return await auth_token_fetch(auth_token_url + '/models/auth_token/' + id, {
        method: 'DELETE'
    });
};

sdk.models.auth_token.getToken = async (data) => {
    return await auth_token_fetch(auth_token_url + '/models/auth_token/getToken', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var ville_url = 'http://ville-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.ville = {};

const ville_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.ville.create = async (model) => {
    return await ville_fetch(ville_url + '/models/ville', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.ville.getAll = async () => {
    return await ville_fetch(ville_url + '/models/ville');
};

sdk.models.ville.getOne = async (id) => {
    return await ville_fetch(ville_url + '/models/ville/' + id);
};

sdk.models.ville.update = async (id, model) => {
    return await ville_fetch(ville_url + '/models/ville/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.ville.delete = async (id) => {
    return await ville_fetch(ville_url + '/models/ville/' + id, {
        method: 'DELETE'
    });
};

sdk.models.ville.import = async (data) => {
    return await ville_fetch(ville_url + '/models/ville/import', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.ville.getStateCities = async (data) => {
    return await ville_fetch(ville_url + '/models/ville/getStateCities', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.ville.getCity = async (data) => {
    return await ville_fetch(ville_url + '/models/ville/getCity', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var post_url = 'http://post-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.post = {};

const post_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.post.create = async (model) => {
    return await post_fetch(post_url + '/models/post', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.post.getAll = async () => {
    return await post_fetch(post_url + '/models/post');
};

sdk.models.post.getOne = async (id) => {
    return await post_fetch(post_url + '/models/post/' + id);
};

sdk.models.post.update = async (id, model) => {
    return await post_fetch(post_url + '/models/post/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.post.delete = async (id) => {
    return await post_fetch(post_url + '/models/post/' + id, {
        method: 'DELETE'
    });
};

sdk.models.post.getUserWall = async (data) => {
    return await post_fetch(post_url + '/models/post/getUserWall', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.post.getPageWall = async (data) => {
    return await post_fetch(post_url + '/models/post/getPageWall', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.post.search = async (data) => {
    return await post_fetch(post_url + '/models/post/search', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.post.getVideos = async (data) => {
    return await post_fetch(post_url + '/models/post/getVideos', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.post.getUserPosts = async (data) => {
    return await post_fetch(post_url + '/models/post/getUserPosts', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.post.onCreate = async (data) => {
    return await post_fetch(post_url + '/models/post/onCreate', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.post.getGroupWall = async (data) => {
    return await post_fetch(post_url + '/models/post/getGroupWall', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.post.createPagePost = async (data) => {
    return await post_fetch(post_url + '/models/post/createPagePost', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.post.createGroupPost = async (data) => {
    return await post_fetch(post_url + '/models/post/createGroupPost', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.post.getViralPosts = async (data) => {
    return await post_fetch(post_url + '/models/post/getViralPosts', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.post.deletePost = async (data) => {
    return await post_fetch(post_url + '/models/post/deletePost', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.post.randomVideo = async (data) => {
    return await post_fetch(post_url + '/models/post/randomVideo', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.post.getYoutubeVideo = async (data) => {
    return await post_fetch(post_url + '/models/post/getYoutubeVideo', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.post.isYoutubeExist = async (data) => {
    return await post_fetch(post_url + '/models/post/isYoutubeExist', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.post.getYoutubePost = async (data) => {
    return await post_fetch(post_url + '/models/post/getYoutubePost', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.post.getPost = async (data) => {
    return await post_fetch(post_url + '/models/post/getPost', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.post.onNewPost = async (data) => {
    return await post_fetch(post_url + '/models/post/onNewPost', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.post.getPageAveragePostByDay = async (data) => {
    return await post_fetch(post_url + '/models/post/getPageAveragePostByDay', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.post.increaseShare = async (data) => {
    return await post_fetch(post_url + '/models/post/increaseShare', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.post.getLastStats = async (data) => {
    return await post_fetch(post_url + '/models/post/getLastStats', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.post.getLastPosts = async (data) => {
    return await post_fetch(post_url + '/models/post/getLastPosts', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.post.signal = async (data) => {
    return await post_fetch(post_url + '/models/post/signal', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.post.initModel = async (data) => {
    return await post_fetch(post_url + '/models/post/initModel', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.post.cleanup = async (data) => {
    return await post_fetch(post_url + '/models/post/cleanup', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var SocialPages_url = 'http://SocialPages-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.SocialPages = {};

const SocialPages_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.SocialPages.create = async (model) => {
    return await SocialPages_fetch(SocialPages_url + '/models/SocialPages', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.SocialPages.getAll = async () => {
    return await SocialPages_fetch(SocialPages_url + '/models/SocialPages');
};

sdk.models.SocialPages.getOne = async (id) => {
    return await SocialPages_fetch(SocialPages_url + '/models/SocialPages/' + id);
};

sdk.models.SocialPages.update = async (id, model) => {
    return await SocialPages_fetch(SocialPages_url + '/models/SocialPages/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.SocialPages.delete = async (id) => {
    return await SocialPages_fetch(SocialPages_url + '/models/SocialPages/' + id, {
        method: 'DELETE'
    });
};

sdk.models.SocialPages.myPages = async (data) => {
    return await SocialPages_fetch(SocialPages_url + '/models/SocialPages/myPages', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.SocialPages.search = async (data) => {
    return await SocialPages_fetch(SocialPages_url + '/models/SocialPages/search', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.SocialPages.suggestions = async (data) => {
    return await SocialPages_fetch(SocialPages_url + '/models/SocialPages/suggestions', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.SocialPages.getBoostedPage = async (data) => {
    return await SocialPages_fetch(SocialPages_url + '/models/SocialPages/getBoostedPage', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.SocialPages.stats = async (data) => {
    return await SocialPages_fetch(SocialPages_url + '/models/SocialPages/stats', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.SocialPages.getBalance = async (data) => {
    return await SocialPages_fetch(SocialPages_url + '/models/SocialPages/getBalance', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.SocialPages.chargePage = async (data) => {
    return await SocialPages_fetch(SocialPages_url + '/models/SocialPages/chargePage', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var PeupleUser_url = 'http://PeupleUser-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.PeupleUser = {};

const PeupleUser_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.PeupleUser.create = async (model) => {
    return await PeupleUser_fetch(PeupleUser_url + '/models/PeupleUser', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.PeupleUser.getAll = async () => {
    return await PeupleUser_fetch(PeupleUser_url + '/models/PeupleUser');
};

sdk.models.PeupleUser.getOne = async (id) => {
    return await PeupleUser_fetch(PeupleUser_url + '/models/PeupleUser/' + id);
};

sdk.models.PeupleUser.update = async (id, model) => {
    return await PeupleUser_fetch(PeupleUser_url + '/models/PeupleUser/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.PeupleUser.delete = async (id) => {
    return await PeupleUser_fetch(PeupleUser_url + '/models/PeupleUser/' + id, {
        method: 'DELETE'
    });
};

sdk.models.PeupleUser.login = async (data) => {
    return await PeupleUser_fetch(PeupleUser_url + '/models/PeupleUser/login', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.PeupleUser.getMySelf = async (data) => {
    return await PeupleUser_fetch(PeupleUser_url + '/models/PeupleUser/getMySelf', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.PeupleUser.register = async (data) => {
    return await PeupleUser_fetch(PeupleUser_url + '/models/PeupleUser/register', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.PeupleUser.search = async (data) => {
    return await PeupleUser_fetch(PeupleUser_url + '/models/PeupleUser/search', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.PeupleUser.onUpdate = async (data) => {
    return await PeupleUser_fetch(PeupleUser_url + '/models/PeupleUser/onUpdate', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.PeupleUser.getRecoverCode = async (data) => {
    return await PeupleUser_fetch(PeupleUser_url + '/models/PeupleUser/getRecoverCode', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.PeupleUser.changePassword = async (data) => {
    return await PeupleUser_fetch(PeupleUser_url + '/models/PeupleUser/changePassword', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.PeupleUser.getAccountBalance = async (data) => {
    return await PeupleUser_fetch(PeupleUser_url + '/models/PeupleUser/getAccountBalance', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.PeupleUser.upgrade = async (data) => {
    return await PeupleUser_fetch(PeupleUser_url + '/models/PeupleUser/upgrade', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.PeupleUser.getAccount = async (data) => {
    return await PeupleUser_fetch(PeupleUser_url + '/models/PeupleUser/getAccount', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.PeupleUser.getSuggestions = async (data) => {
    return await PeupleUser_fetch(PeupleUser_url + '/models/PeupleUser/getSuggestions', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.PeupleUser.getReferals = async (data) => {
    return await PeupleUser_fetch(PeupleUser_url + '/models/PeupleUser/getReferals', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.PeupleUser.findByEmail = async (data) => {
    return await PeupleUser_fetch(PeupleUser_url + '/models/PeupleUser/findByEmail', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.PeupleUser.getUserAccount = async (data) => {
    return await PeupleUser_fetch(PeupleUser_url + '/models/PeupleUser/getUserAccount', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.PeupleUser.hesOnline = async (data) => {
    return await PeupleUser_fetch(PeupleUser_url + '/models/PeupleUser/hesOnline', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.PeupleUser.getUser = async (data) => {
    return await PeupleUser_fetch(PeupleUser_url + '/models/PeupleUser/getUser', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var SocialNotification_url = 'http://SocialNotification-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.SocialNotification = {};

const SocialNotification_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.SocialNotification.create = async (model) => {
    return await SocialNotification_fetch(SocialNotification_url + '/models/SocialNotification', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.SocialNotification.getAll = async () => {
    return await SocialNotification_fetch(SocialNotification_url + '/models/SocialNotification');
};

sdk.models.SocialNotification.getOne = async (id) => {
    return await SocialNotification_fetch(SocialNotification_url + '/models/SocialNotification/' + id);
};

sdk.models.SocialNotification.update = async (id, model) => {
    return await SocialNotification_fetch(SocialNotification_url + '/models/SocialNotification/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.SocialNotification.delete = async (id) => {
    return await SocialNotification_fetch(SocialNotification_url + '/models/SocialNotification/' + id, {
        method: 'DELETE'
    });
};

sdk.models.SocialNotification.myNotifications = async (data) => {
    return await SocialNotification_fetch(SocialNotification_url + '/models/SocialNotification/myNotifications', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.SocialNotification.onCreate = async (data) => {
    return await SocialNotification_fetch(SocialNotification_url + '/models/SocialNotification/onCreate', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.SocialNotification.initModel = async (data) => {
    return await SocialNotification_fetch(SocialNotification_url + '/models/SocialNotification/initModel', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.SocialNotification.unseenCount = async (data) => {
    return await SocialNotification_fetch(SocialNotification_url + '/models/SocialNotification/unseenCount', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.SocialNotification.markSeen = async (data) => {
    return await SocialNotification_fetch(SocialNotification_url + '/models/SocialNotification/markSeen', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.SocialNotification.setTapped = async (data) => {
    return await SocialNotification_fetch(SocialNotification_url + '/models/SocialNotification/setTapped', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.SocialNotification.getCadeauxStats = async (data) => {
    return await SocialNotification_fetch(SocialNotification_url + '/models/SocialNotification/getCadeauxStats', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.SocialNotification.getUnread = async (data) => {
    return await SocialNotification_fetch(SocialNotification_url + '/models/SocialNotification/getUnread', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var PageLike_url = 'http://PageLike-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.PageLike = {};

const PageLike_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.PageLike.create = async (model) => {
    return await PageLike_fetch(PageLike_url + '/models/PageLike', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.PageLike.getAll = async () => {
    return await PageLike_fetch(PageLike_url + '/models/PageLike');
};

sdk.models.PageLike.getOne = async (id) => {
    return await PageLike_fetch(PageLike_url + '/models/PageLike/' + id);
};

sdk.models.PageLike.update = async (id, model) => {
    return await PageLike_fetch(PageLike_url + '/models/PageLike/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.PageLike.delete = async (id) => {
    return await PageLike_fetch(PageLike_url + '/models/PageLike/' + id, {
        method: 'DELETE'
    });
};

sdk.models.PageLike.getUserLikes = async (data) => {
    return await PageLike_fetch(PageLike_url + '/models/PageLike/getUserLikes', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.PageLike.getPageLikes = async (data) => {
    return await PageLike_fetch(PageLike_url + '/models/PageLike/getPageLikes', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.PageLike.likeCount = async (data) => {
    return await PageLike_fetch(PageLike_url + '/models/PageLike/likeCount', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.PageLike.hasLiked = async (data) => {
    return await PageLike_fetch(PageLike_url + '/models/PageLike/hasLiked', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.PageLike.onCreate = async (data) => {
    return await PageLike_fetch(PageLike_url + '/models/PageLike/onCreate', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var WeeklyContestWinner_url = 'http://WeeklyContestWinner-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.WeeklyContestWinner = {};

const WeeklyContestWinner_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.WeeklyContestWinner.create = async (model) => {
    return await WeeklyContestWinner_fetch(WeeklyContestWinner_url + '/models/WeeklyContestWinner', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.WeeklyContestWinner.getAll = async () => {
    return await WeeklyContestWinner_fetch(WeeklyContestWinner_url + '/models/WeeklyContestWinner');
};

sdk.models.WeeklyContestWinner.getOne = async (id) => {
    return await WeeklyContestWinner_fetch(WeeklyContestWinner_url + '/models/WeeklyContestWinner/' + id);
};

sdk.models.WeeklyContestWinner.update = async (id, model) => {
    return await WeeklyContestWinner_fetch(WeeklyContestWinner_url + '/models/WeeklyContestWinner/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.WeeklyContestWinner.delete = async (id) => {
    return await WeeklyContestWinner_fetch(WeeklyContestWinner_url + '/models/WeeklyContestWinner/' + id, {
        method: 'DELETE'
    });
};
var ConcoursTicket_url = 'http://ConcoursTicket-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.ConcoursTicket = {};

const ConcoursTicket_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.ConcoursTicket.create = async (model) => {
    return await ConcoursTicket_fetch(ConcoursTicket_url + '/models/ConcoursTicket', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.ConcoursTicket.getAll = async () => {
    return await ConcoursTicket_fetch(ConcoursTicket_url + '/models/ConcoursTicket');
};

sdk.models.ConcoursTicket.getOne = async (id) => {
    return await ConcoursTicket_fetch(ConcoursTicket_url + '/models/ConcoursTicket/' + id);
};

sdk.models.ConcoursTicket.update = async (id, model) => {
    return await ConcoursTicket_fetch(ConcoursTicket_url + '/models/ConcoursTicket/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.ConcoursTicket.delete = async (id) => {
    return await ConcoursTicket_fetch(ConcoursTicket_url + '/models/ConcoursTicket/' + id, {
        method: 'DELETE'
    });
};

sdk.models.ConcoursTicket.getMyTickets = async (data) => {
    return await ConcoursTicket_fetch(ConcoursTicket_url + '/models/ConcoursTicket/getMyTickets', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.ConcoursTicket.askAticket = async (data) => {
    return await ConcoursTicket_fetch(ConcoursTicket_url + '/models/ConcoursTicket/askAticket', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.ConcoursTicket.getTickets = async (data) => {
    return await ConcoursTicket_fetch(ConcoursTicket_url + '/models/ConcoursTicket/getTickets', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.ConcoursTicket.onCreate = async (data) => {
    return await ConcoursTicket_fetch(ConcoursTicket_url + '/models/ConcoursTicket/onCreate', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var QuizGame_url = 'http://QuizGame-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.QuizGame = {};

const QuizGame_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.QuizGame.create = async (model) => {
    return await QuizGame_fetch(QuizGame_url + '/models/QuizGame', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.QuizGame.getAll = async () => {
    return await QuizGame_fetch(QuizGame_url + '/models/QuizGame');
};

sdk.models.QuizGame.getOne = async (id) => {
    return await QuizGame_fetch(QuizGame_url + '/models/QuizGame/' + id);
};

sdk.models.QuizGame.update = async (id, model) => {
    return await QuizGame_fetch(QuizGame_url + '/models/QuizGame/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.QuizGame.delete = async (id) => {
    return await QuizGame_fetch(QuizGame_url + '/models/QuizGame/' + id, {
        method: 'DELETE'
    });
};

sdk.models.QuizGame.onCreate = async (data) => {
    return await QuizGame_fetch(QuizGame_url + '/models/QuizGame/onCreate', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.QuizGame.upgrade = async (data) => {
    return await QuizGame_fetch(QuizGame_url + '/models/QuizGame/upgrade', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.QuizGame.getScores = async (data) => {
    return await QuizGame_fetch(QuizGame_url + '/models/QuizGame/getScores', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var SocialMessage_url = 'http://SocialMessage-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.SocialMessage = {};

const SocialMessage_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.SocialMessage.create = async (model) => {
    return await SocialMessage_fetch(SocialMessage_url + '/models/SocialMessage', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.SocialMessage.getAll = async () => {
    return await SocialMessage_fetch(SocialMessage_url + '/models/SocialMessage');
};

sdk.models.SocialMessage.getOne = async (id) => {
    return await SocialMessage_fetch(SocialMessage_url + '/models/SocialMessage/' + id);
};

sdk.models.SocialMessage.update = async (id, model) => {
    return await SocialMessage_fetch(SocialMessage_url + '/models/SocialMessage/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.SocialMessage.delete = async (id) => {
    return await SocialMessage_fetch(SocialMessage_url + '/models/SocialMessage/' + id, {
        method: 'DELETE'
    });
};

sdk.models.SocialMessage.getDiscussions = async (data) => {
    return await SocialMessage_fetch(SocialMessage_url + '/models/SocialMessage/getDiscussions', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.SocialMessage.getDiscussion = async (data) => {
    return await SocialMessage_fetch(SocialMessage_url + '/models/SocialMessage/getDiscussion', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.SocialMessage.sendMessage = async (data) => {
    return await SocialMessage_fetch(SocialMessage_url + '/models/SocialMessage/sendMessage', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.SocialMessage.setMsgSeen = async (data) => {
    return await SocialMessage_fetch(SocialMessage_url + '/models/SocialMessage/setMsgSeen', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.SocialMessage.countUnread = async (data) => {
    return await SocialMessage_fetch(SocialMessage_url + '/models/SocialMessage/countUnread', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.SocialMessage.getUnreadStats = async (data) => {
    return await SocialMessage_fetch(SocialMessage_url + '/models/SocialMessage/getUnreadStats', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var WeeklyContest_url = 'http://WeeklyContest-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.WeeklyContest = {};

const WeeklyContest_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.WeeklyContest.create = async (model) => {
    return await WeeklyContest_fetch(WeeklyContest_url + '/models/WeeklyContest', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.WeeklyContest.getAll = async () => {
    return await WeeklyContest_fetch(WeeklyContest_url + '/models/WeeklyContest');
};

sdk.models.WeeklyContest.getOne = async (id) => {
    return await WeeklyContest_fetch(WeeklyContest_url + '/models/WeeklyContest/' + id);
};

sdk.models.WeeklyContest.update = async (id, model) => {
    return await WeeklyContest_fetch(WeeklyContest_url + '/models/WeeklyContest/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.WeeklyContest.delete = async (id) => {
    return await WeeklyContest_fetch(WeeklyContest_url + '/models/WeeklyContest/' + id, {
        method: 'DELETE'
    });
};
var PostsLike_url = 'http://PostsLike-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.PostsLike = {};

const PostsLike_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.PostsLike.create = async (model) => {
    return await PostsLike_fetch(PostsLike_url + '/models/PostsLike', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.PostsLike.getAll = async () => {
    return await PostsLike_fetch(PostsLike_url + '/models/PostsLike');
};

sdk.models.PostsLike.getOne = async (id) => {
    return await PostsLike_fetch(PostsLike_url + '/models/PostsLike/' + id);
};

sdk.models.PostsLike.update = async (id, model) => {
    return await PostsLike_fetch(PostsLike_url + '/models/PostsLike/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.PostsLike.delete = async (id) => {
    return await PostsLike_fetch(PostsLike_url + '/models/PostsLike/' + id, {
        method: 'DELETE'
    });
};

sdk.models.PostsLike.hasLiked = async (data) => {
    return await PostsLike_fetch(PostsLike_url + '/models/PostsLike/hasLiked', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.PostsLike.deleteMyLike = async (data) => {
    return await PostsLike_fetch(PostsLike_url + '/models/PostsLike/deleteMyLike', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.PostsLike.getPostLikes = async (data) => {
    return await PostsLike_fetch(PostsLike_url + '/models/PostsLike/getPostLikes', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.PostsLike.onCreate = async (data) => {
    return await PostsLike_fetch(PostsLike_url + '/models/PostsLike/onCreate', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.PostsLike.getUserLikes = async (data) => {
    return await PostsLike_fetch(PostsLike_url + '/models/PostsLike/getUserLikes', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.PostsLike.getLastHundred = async (data) => {
    return await PostsLike_fetch(PostsLike_url + '/models/PostsLike/getLastHundred', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.PostsLike.getPostsForGroupUser = async (data) => {
    return await PostsLike_fetch(PostsLike_url + '/models/PostsLike/getPostsForGroupUser', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var TaskModel_url = 'http://TaskModel-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.TaskModel = {};

const TaskModel_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.TaskModel.create = async (model) => {
    return await TaskModel_fetch(TaskModel_url + '/models/TaskModel', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.TaskModel.getAll = async () => {
    return await TaskModel_fetch(TaskModel_url + '/models/TaskModel');
};

sdk.models.TaskModel.getOne = async (id) => {
    return await TaskModel_fetch(TaskModel_url + '/models/TaskModel/' + id);
};

sdk.models.TaskModel.update = async (id, model) => {
    return await TaskModel_fetch(TaskModel_url + '/models/TaskModel/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.TaskModel.delete = async (id) => {
    return await TaskModel_fetch(TaskModel_url + '/models/TaskModel/' + id, {
        method: 'DELETE'
    });
};

sdk.models.TaskModel.getModels = async (data) => {
    return await TaskModel_fetch(TaskModel_url + '/models/TaskModel/getModels', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.TaskModel.updateModel = async (data) => {
    return await TaskModel_fetch(TaskModel_url + '/models/TaskModel/updateModel', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var UsrMeta_url = 'http://UsrMeta-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.UsrMeta = {};

const UsrMeta_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.UsrMeta.create = async (model) => {
    return await UsrMeta_fetch(UsrMeta_url + '/models/UsrMeta', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.UsrMeta.getAll = async () => {
    return await UsrMeta_fetch(UsrMeta_url + '/models/UsrMeta');
};

sdk.models.UsrMeta.getOne = async (id) => {
    return await UsrMeta_fetch(UsrMeta_url + '/models/UsrMeta/' + id);
};

sdk.models.UsrMeta.update = async (id, model) => {
    return await UsrMeta_fetch(UsrMeta_url + '/models/UsrMeta/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.UsrMeta.delete = async (id) => {
    return await UsrMeta_fetch(UsrMeta_url + '/models/UsrMeta/' + id, {
        method: 'DELETE'
    });
};

sdk.models.UsrMeta.getMyMeta = async (data) => {
    return await UsrMeta_fetch(UsrMeta_url + '/models/UsrMeta/getMyMeta', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.UsrMeta.setMyMeta = async (data) => {
    return await UsrMeta_fetch(UsrMeta_url + '/models/UsrMeta/setMyMeta', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.UsrMeta.getMeta = async (data) => {
    return await UsrMeta_fetch(UsrMeta_url + '/models/UsrMeta/getMeta', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.UsrMeta.doProfil = async (data) => {
    return await UsrMeta_fetch(UsrMeta_url + '/models/UsrMeta/doProfil', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.UsrMeta.setMeta = async (data) => {
    return await UsrMeta_fetch(UsrMeta_url + '/models/UsrMeta/setMeta', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var PostsTime_url = 'http://PostsTime-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.PostsTime = {};

const PostsTime_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.PostsTime.create = async (model) => {
    return await PostsTime_fetch(PostsTime_url + '/models/PostsTime', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.PostsTime.getAll = async () => {
    return await PostsTime_fetch(PostsTime_url + '/models/PostsTime');
};

sdk.models.PostsTime.getOne = async (id) => {
    return await PostsTime_fetch(PostsTime_url + '/models/PostsTime/' + id);
};

sdk.models.PostsTime.update = async (id, model) => {
    return await PostsTime_fetch(PostsTime_url + '/models/PostsTime/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.PostsTime.delete = async (id) => {
    return await PostsTime_fetch(PostsTime_url + '/models/PostsTime/' + id, {
        method: 'DELETE'
    });
};

sdk.models.PostsTime.getVideosViews = async (data) => {
    return await PostsTime_fetch(PostsTime_url + '/models/PostsTime/getVideosViews', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.PostsTime.setPostTime = async (data) => {
    return await PostsTime_fetch(PostsTime_url + '/models/PostsTime/setPostTime', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.PostsTime.onCreate = async (data) => {
    return await PostsTime_fetch(PostsTime_url + '/models/PostsTime/onCreate', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.PostsTime.getVideoTimes = async (data) => {
    return await PostsTime_fetch(PostsTime_url + '/models/PostsTime/getVideoTimes', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var Task_url = 'http://Task-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.Task = {};

const Task_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.Task.create = async (model) => {
    return await Task_fetch(Task_url + '/models/Task', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.Task.getAll = async () => {
    return await Task_fetch(Task_url + '/models/Task');
};

sdk.models.Task.getOne = async (id) => {
    return await Task_fetch(Task_url + '/models/Task/' + id);
};

sdk.models.Task.update = async (id, model) => {
    return await Task_fetch(Task_url + '/models/Task/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.Task.delete = async (id) => {
    return await Task_fetch(Task_url + '/models/Task/' + id, {
        method: 'DELETE'
    });
};

sdk.models.Task.getTaskAvailable = async (data) => {
    return await Task_fetch(Task_url + '/models/Task/getTaskAvailable', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.Task.getMyServices = async (data) => {
    return await Task_fetch(Task_url + '/models/Task/getMyServices', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.Task.getMyTasks = async (data) => {
    return await Task_fetch(Task_url + '/models/Task/getMyTasks', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.Task.onCreate = async (data) => {
    return await Task_fetch(Task_url + '/models/Task/onCreate', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.Task.hire = async (data) => {
    return await Task_fetch(Task_url + '/models/Task/hire', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.Task.completeTask = async (data) => {
    return await Task_fetch(Task_url + '/models/Task/completeTask', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.Task.createBnb = async (data) => {
    return await Task_fetch(Task_url + '/models/Task/createBnb', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.Task.createTask = async (data) => {
    return await Task_fetch(Task_url + '/models/Task/createTask', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.Task.timer = async (data) => {
    return await Task_fetch(Task_url + '/models/Task/timer', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.Task.yearSummary = async (data) => {
    return await Task_fetch(Task_url + '/models/Task/yearSummary', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.Task.taskApproved = async (data) => {
    return await Task_fetch(Task_url + '/models/Task/taskApproved', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.Task.getTask = async (data) => {
    return await Task_fetch(Task_url + '/models/Task/getTask', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.Task.updateReview = async (data) => {
    return await Task_fetch(Task_url + '/models/Task/updateReview', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var TaskApply_url = 'http://TaskApply-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.TaskApply = {};

const TaskApply_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.TaskApply.create = async (model) => {
    return await TaskApply_fetch(TaskApply_url + '/models/TaskApply', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.TaskApply.getAll = async () => {
    return await TaskApply_fetch(TaskApply_url + '/models/TaskApply');
};

sdk.models.TaskApply.getOne = async (id) => {
    return await TaskApply_fetch(TaskApply_url + '/models/TaskApply/' + id);
};

sdk.models.TaskApply.update = async (id, model) => {
    return await TaskApply_fetch(TaskApply_url + '/models/TaskApply/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.TaskApply.delete = async (id) => {
    return await TaskApply_fetch(TaskApply_url + '/models/TaskApply/' + id, {
        method: 'DELETE'
    });
};

sdk.models.TaskApply.hasApplied = async (data) => {
    return await TaskApply_fetch(TaskApply_url + '/models/TaskApply/hasApplied', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.TaskApply.getAppliers = async (data) => {
    return await TaskApply_fetch(TaskApply_url + '/models/TaskApply/getAppliers', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.TaskApply.onCreate = async (data) => {
    return await TaskApply_fetch(TaskApply_url + '/models/TaskApply/onCreate', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var Places_url = 'http://Places-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.Places = {};

const Places_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.Places.create = async (model) => {
    return await Places_fetch(Places_url + '/models/Places', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.Places.getAll = async () => {
    return await Places_fetch(Places_url + '/models/Places');
};

sdk.models.Places.getOne = async (id) => {
    return await Places_fetch(Places_url + '/models/Places/' + id);
};

sdk.models.Places.update = async (id, model) => {
    return await Places_fetch(Places_url + '/models/Places/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.Places.delete = async (id) => {
    return await Places_fetch(Places_url + '/models/Places/' + id, {
        method: 'DELETE'
    });
};

sdk.models.Places.getNearbyPlaces = async (data) => {
    return await Places_fetch(Places_url + '/models/Places/getNearbyPlaces', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.Places.getPlace = async (data) => {
    return await Places_fetch(Places_url + '/models/Places/getPlace', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.Places.getCityPlaces = async (data) => {
    return await Places_fetch(Places_url + '/models/Places/getCityPlaces', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.Places.import = async (data) => {
    return await Places_fetch(Places_url + '/models/Places/import', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var TaskUsrModel_url = 'http://TaskUsrModel-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.TaskUsrModel = {};

const TaskUsrModel_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.TaskUsrModel.create = async (model) => {
    return await TaskUsrModel_fetch(TaskUsrModel_url + '/models/TaskUsrModel', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.TaskUsrModel.getAll = async () => {
    return await TaskUsrModel_fetch(TaskUsrModel_url + '/models/TaskUsrModel');
};

sdk.models.TaskUsrModel.getOne = async (id) => {
    return await TaskUsrModel_fetch(TaskUsrModel_url + '/models/TaskUsrModel/' + id);
};

sdk.models.TaskUsrModel.update = async (id, model) => {
    return await TaskUsrModel_fetch(TaskUsrModel_url + '/models/TaskUsrModel/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.TaskUsrModel.delete = async (id) => {
    return await TaskUsrModel_fetch(TaskUsrModel_url + '/models/TaskUsrModel/' + id, {
        method: 'DELETE'
    });
};

sdk.models.TaskUsrModel.getMyInscriptions = async (data) => {
    return await TaskUsrModel_fetch(TaskUsrModel_url + '/models/TaskUsrModel/getMyInscriptions', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.TaskUsrModel.createThisModel = async (data) => {
    return await TaskUsrModel_fetch(TaskUsrModel_url + '/models/TaskUsrModel/createThisModel', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.TaskUsrModel.deleteThisModel = async (data) => {
    return await TaskUsrModel_fetch(TaskUsrModel_url + '/models/TaskUsrModel/deleteThisModel', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.TaskUsrModel.workersOfModel = async (data) => {
    return await TaskUsrModel_fetch(TaskUsrModel_url + '/models/TaskUsrModel/workersOfModel', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.TaskUsrModel.getWorkers = async (data) => {
    return await TaskUsrModel_fetch(TaskUsrModel_url + '/models/TaskUsrModel/getWorkers', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.TaskUsrModel.getUserModels = async (data) => {
    return await TaskUsrModel_fetch(TaskUsrModel_url + '/models/TaskUsrModel/getUserModels', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.TaskUsrModel.getMapUsers = async (data) => {
    return await TaskUsrModel_fetch(TaskUsrModel_url + '/models/TaskUsrModel/getMapUsers', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var FcmToken_url = 'http://FcmToken-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.FcmToken = {};

const FcmToken_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.FcmToken.create = async (model) => {
    return await FcmToken_fetch(FcmToken_url + '/models/FcmToken', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.FcmToken.getAll = async () => {
    return await FcmToken_fetch(FcmToken_url + '/models/FcmToken');
};

sdk.models.FcmToken.getOne = async (id) => {
    return await FcmToken_fetch(FcmToken_url + '/models/FcmToken/' + id);
};

sdk.models.FcmToken.update = async (id, model) => {
    return await FcmToken_fetch(FcmToken_url + '/models/FcmToken/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.FcmToken.delete = async (id) => {
    return await FcmToken_fetch(FcmToken_url + '/models/FcmToken/' + id, {
        method: 'DELETE'
    });
};

sdk.models.FcmToken.getTokensOf = async (data) => {
    return await FcmToken_fetch(FcmToken_url + '/models/FcmToken/getTokensOf', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var Followers_url = 'http://Followers-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.Followers = {};

const Followers_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.Followers.create = async (model) => {
    return await Followers_fetch(Followers_url + '/models/Followers', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.Followers.getAll = async () => {
    return await Followers_fetch(Followers_url + '/models/Followers');
};

sdk.models.Followers.getOne = async (id) => {
    return await Followers_fetch(Followers_url + '/models/Followers/' + id);
};

sdk.models.Followers.update = async (id, model) => {
    return await Followers_fetch(Followers_url + '/models/Followers/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.Followers.delete = async (id) => {
    return await Followers_fetch(Followers_url + '/models/Followers/' + id, {
        method: 'DELETE'
    });
};

sdk.models.Followers.getFollower = async (data) => {
    return await Followers_fetch(Followers_url + '/models/Followers/getFollower', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.Followers.isFollowing = async (data) => {
    return await Followers_fetch(Followers_url + '/models/Followers/isFollowing', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.Followers.onCreate = async (data) => {
    return await Followers_fetch(Followers_url + '/models/Followers/onCreate', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.Followers.getFollowerOf = async (data) => {
    return await Followers_fetch(Followers_url + '/models/Followers/getFollowerOf', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var SocialComment_url = 'http://SocialComment-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.SocialComment = {};

const SocialComment_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.SocialComment.create = async (model) => {
    return await SocialComment_fetch(SocialComment_url + '/models/SocialComment', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.SocialComment.getAll = async () => {
    return await SocialComment_fetch(SocialComment_url + '/models/SocialComment');
};

sdk.models.SocialComment.getOne = async (id) => {
    return await SocialComment_fetch(SocialComment_url + '/models/SocialComment/' + id);
};

sdk.models.SocialComment.update = async (id, model) => {
    return await SocialComment_fetch(SocialComment_url + '/models/SocialComment/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.SocialComment.delete = async (id) => {
    return await SocialComment_fetch(SocialComment_url + '/models/SocialComment/' + id, {
        method: 'DELETE'
    });
};

sdk.models.SocialComment.getPostComments = async (data) => {
    return await SocialComment_fetch(SocialComment_url + '/models/SocialComment/getPostComments', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.SocialComment.onCreate = async (data) => {
    return await SocialComment_fetch(SocialComment_url + '/models/SocialComment/onCreate', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.SocialComment.getLastHundred = async (data) => {
    return await SocialComment_fetch(SocialComment_url + '/models/SocialComment/getLastHundred', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.SocialComment.getUserComments = async (data) => {
    return await SocialComment_fetch(SocialComment_url + '/models/SocialComment/getUserComments', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.SocialComment.beforeCreate = async (data) => {
    return await SocialComment_fetch(SocialComment_url + '/models/SocialComment/beforeCreate', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.SocialComment.getComment = async (data) => {
    return await SocialComment_fetch(SocialComment_url + '/models/SocialComment/getComment', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var RefIps_url = 'http://RefIps-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.RefIps = {};

const RefIps_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.RefIps.create = async (model) => {
    return await RefIps_fetch(RefIps_url + '/models/RefIps', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.RefIps.getAll = async () => {
    return await RefIps_fetch(RefIps_url + '/models/RefIps');
};

sdk.models.RefIps.getOne = async (id) => {
    return await RefIps_fetch(RefIps_url + '/models/RefIps/' + id);
};

sdk.models.RefIps.update = async (id, model) => {
    return await RefIps_fetch(RefIps_url + '/models/RefIps/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.RefIps.delete = async (id) => {
    return await RefIps_fetch(RefIps_url + '/models/RefIps/' + id, {
        method: 'DELETE'
    });
};

sdk.models.RefIps.findWithIp = async (data) => {
    return await RefIps_fetch(RefIps_url + '/models/RefIps/findWithIp', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var UsrAddress_url = 'http://UsrAddress-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.UsrAddress = {};

const UsrAddress_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.UsrAddress.create = async (model) => {
    return await UsrAddress_fetch(UsrAddress_url + '/models/UsrAddress', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.UsrAddress.getAll = async () => {
    return await UsrAddress_fetch(UsrAddress_url + '/models/UsrAddress');
};

sdk.models.UsrAddress.getOne = async (id) => {
    return await UsrAddress_fetch(UsrAddress_url + '/models/UsrAddress/' + id);
};

sdk.models.UsrAddress.update = async (id, model) => {
    return await UsrAddress_fetch(UsrAddress_url + '/models/UsrAddress/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.UsrAddress.delete = async (id) => {
    return await UsrAddress_fetch(UsrAddress_url + '/models/UsrAddress/' + id, {
        method: 'DELETE'
    });
};

sdk.models.UsrAddress.getMyAddress = async (data) => {
    return await UsrAddress_fetch(UsrAddress_url + '/models/UsrAddress/getMyAddress', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.UsrAddress.onCreate = async (data) => {
    return await UsrAddress_fetch(UsrAddress_url + '/models/UsrAddress/onCreate', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.UsrAddress.onUpdate = async (data) => {
    return await UsrAddress_fetch(UsrAddress_url + '/models/UsrAddress/onUpdate', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.UsrAddress.getUserAddress = async (data) => {
    return await UsrAddress_fetch(UsrAddress_url + '/models/UsrAddress/getUserAddress', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var UsrMedia_url = 'http://UsrMedia-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.UsrMedia = {};

const UsrMedia_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.UsrMedia.create = async (model) => {
    return await UsrMedia_fetch(UsrMedia_url + '/models/UsrMedia', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.UsrMedia.getAll = async () => {
    return await UsrMedia_fetch(UsrMedia_url + '/models/UsrMedia');
};

sdk.models.UsrMedia.getOne = async (id) => {
    return await UsrMedia_fetch(UsrMedia_url + '/models/UsrMedia/' + id);
};

sdk.models.UsrMedia.update = async (id, model) => {
    return await UsrMedia_fetch(UsrMedia_url + '/models/UsrMedia/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.UsrMedia.delete = async (id) => {
    return await UsrMedia_fetch(UsrMedia_url + '/models/UsrMedia/' + id, {
        method: 'DELETE'
    });
};

sdk.models.UsrMedia.uploadFile = async (data) => {
    return await UsrMedia_fetch(UsrMedia_url + '/models/UsrMedia/uploadFile', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.UsrMedia.onCreate = async (data) => {
    return await UsrMedia_fetch(UsrMedia_url + '/models/UsrMedia/onCreate', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.UsrMedia.uploadAd = async (data) => {
    return await UsrMedia_fetch(UsrMedia_url + '/models/UsrMedia/uploadAd', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.UsrMedia.uploadStorage = async (data) => {
    return await UsrMedia_fetch(UsrMedia_url + '/models/UsrMedia/uploadStorage', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.UsrMedia.uploadItemMedia = async (data) => {
    return await UsrMedia_fetch(UsrMedia_url + '/models/UsrMedia/uploadItemMedia', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.UsrMedia.downloadTo = async (data) => {
    return await UsrMedia_fetch(UsrMedia_url + '/models/UsrMedia/downloadTo', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.UsrMedia.uploadImpot = async (data) => {
    return await UsrMedia_fetch(UsrMedia_url + '/models/UsrMedia/uploadImpot', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.UsrMedia.fileExist = async (data) => {
    return await UsrMedia_fetch(UsrMedia_url + '/models/UsrMedia/fileExist', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.UsrMedia.initModel = async (data) => {
    return await UsrMedia_fetch(UsrMedia_url + '/models/UsrMedia/initModel', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var SocialGroup_url = 'http://SocialGroup-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.SocialGroup = {};

const SocialGroup_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.SocialGroup.create = async (model) => {
    return await SocialGroup_fetch(SocialGroup_url + '/models/SocialGroup', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.SocialGroup.getAll = async () => {
    return await SocialGroup_fetch(SocialGroup_url + '/models/SocialGroup');
};

sdk.models.SocialGroup.getOne = async (id) => {
    return await SocialGroup_fetch(SocialGroup_url + '/models/SocialGroup/' + id);
};

sdk.models.SocialGroup.update = async (id, model) => {
    return await SocialGroup_fetch(SocialGroup_url + '/models/SocialGroup/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.SocialGroup.delete = async (id) => {
    return await SocialGroup_fetch(SocialGroup_url + '/models/SocialGroup/' + id, {
        method: 'DELETE'
    });
};

sdk.models.SocialGroup.myGroups = async (data) => {
    return await SocialGroup_fetch(SocialGroup_url + '/models/SocialGroup/myGroups', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.SocialGroup.search = async (data) => {
    return await SocialGroup_fetch(SocialGroup_url + '/models/SocialGroup/search', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.SocialGroup.onCreate = async (data) => {
    return await SocialGroup_fetch(SocialGroup_url + '/models/SocialGroup/onCreate', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.SocialGroup.suggestions = async (data) => {
    return await SocialGroup_fetch(SocialGroup_url + '/models/SocialGroup/suggestions', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.SocialGroup.ImMembersOf = async (data) => {
    return await SocialGroup_fetch(SocialGroup_url + '/models/SocialGroup/ImMembersOf', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var QuizQuestion_url = 'http://QuizQuestion-prod-svc.models.svc.cluster.local:8080';
sdk.models.QuizQuestion = {};

const QuizQuestion_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.QuizQuestion.create = async (model) => {
    return await QuizQuestion_fetch(QuizQuestion_url + '/models/QuizQuestion', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.QuizQuestion.getAll = async () => {
    return await QuizQuestion_fetch(QuizQuestion_url + '/models/QuizQuestion');
};

sdk.models.QuizQuestion.getOne = async (id) => {
    return await QuizQuestion_fetch(QuizQuestion_url + '/models/QuizQuestion/' + id);
};

sdk.models.QuizQuestion.update = async (id, model) => {
    return await QuizQuestion_fetch(QuizQuestion_url + '/models/QuizQuestion/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.QuizQuestion.delete = async (id) => {
    return await QuizQuestion_fetch(QuizQuestion_url + '/models/QuizQuestion/' + id, {
        method: 'DELETE'
    });
};

sdk.models.QuizQuestion.import = async (data) => {
    return await QuizQuestion_fetch(QuizQuestion_url + '/models/QuizQuestion/import', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.QuizQuestion.getQuestion = async (data) => {
    return await QuizQuestion_fetch(QuizQuestion_url + '/models/QuizQuestion/getQuestion', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.QuizQuestion.refresh = async (data) => {
    return await QuizQuestion_fetch(QuizQuestion_url + '/models/QuizQuestion/refresh', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var GroupMember_url = 'http://GroupMember-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.GroupMember = {};

const GroupMember_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.GroupMember.create = async (model) => {
    return await GroupMember_fetch(GroupMember_url + '/models/GroupMember', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.GroupMember.getAll = async () => {
    return await GroupMember_fetch(GroupMember_url + '/models/GroupMember');
};

sdk.models.GroupMember.getOne = async (id) => {
    return await GroupMember_fetch(GroupMember_url + '/models/GroupMember/' + id);
};

sdk.models.GroupMember.update = async (id, model) => {
    return await GroupMember_fetch(GroupMember_url + '/models/GroupMember/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.GroupMember.delete = async (id) => {
    return await GroupMember_fetch(GroupMember_url + '/models/GroupMember/' + id, {
        method: 'DELETE'
    });
};

sdk.models.GroupMember.isMember = async (data) => {
    return await GroupMember_fetch(GroupMember_url + '/models/GroupMember/isMember', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.GroupMember.getMembersOf = async (data) => {
    return await GroupMember_fetch(GroupMember_url + '/models/GroupMember/getMembersOf', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.GroupMember.myGroups = async (data) => {
    return await GroupMember_fetch(GroupMember_url + '/models/GroupMember/myGroups', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.GroupMember.likeCount = async (data) => {
    return await GroupMember_fetch(GroupMember_url + '/models/GroupMember/likeCount', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.GroupMember.ImMembersOf = async (data) => {
    return await GroupMember_fetch(GroupMember_url + '/models/GroupMember/ImMembersOf', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var PageCategory_url = 'http://PageCategory-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.PageCategory = {};

const PageCategory_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.PageCategory.create = async (model) => {
    return await PageCategory_fetch(PageCategory_url + '/models/PageCategory', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.PageCategory.getAll = async () => {
    return await PageCategory_fetch(PageCategory_url + '/models/PageCategory');
};

sdk.models.PageCategory.getOne = async (id) => {
    return await PageCategory_fetch(PageCategory_url + '/models/PageCategory/' + id);
};

sdk.models.PageCategory.update = async (id, model) => {
    return await PageCategory_fetch(PageCategory_url + '/models/PageCategory/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.PageCategory.delete = async (id) => {
    return await PageCategory_fetch(PageCategory_url + '/models/PageCategory/' + id, {
        method: 'DELETE'
    });
};
var GroupCategory_url = 'http://GroupCategory-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.GroupCategory = {};

const GroupCategory_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.GroupCategory.create = async (model) => {
    return await GroupCategory_fetch(GroupCategory_url + '/models/GroupCategory', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.GroupCategory.getAll = async () => {
    return await GroupCategory_fetch(GroupCategory_url + '/models/GroupCategory');
};

sdk.models.GroupCategory.getOne = async (id) => {
    return await GroupCategory_fetch(GroupCategory_url + '/models/GroupCategory/' + id);
};

sdk.models.GroupCategory.update = async (id, model) => {
    return await GroupCategory_fetch(GroupCategory_url + '/models/GroupCategory/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.GroupCategory.delete = async (id) => {
    return await GroupCategory_fetch(GroupCategory_url + '/models/GroupCategory/' + id, {
        method: 'DELETE'
    });
};
var Logger_url = 'http://Logger-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.Logger = {};

const Logger_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.Logger.create = async (model) => {
    return await Logger_fetch(Logger_url + '/models/Logger', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.Logger.getAll = async () => {
    return await Logger_fetch(Logger_url + '/models/Logger');
};

sdk.models.Logger.getOne = async (id) => {
    return await Logger_fetch(Logger_url + '/models/Logger/' + id);
};

sdk.models.Logger.update = async (id, model) => {
    return await Logger_fetch(Logger_url + '/models/Logger/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.Logger.delete = async (id) => {
    return await Logger_fetch(Logger_url + '/models/Logger/' + id, {
        method: 'DELETE'
    });
};

sdk.models.Logger.getLastLogs = async (data) => {
    return await Logger_fetch(Logger_url + '/models/Logger/getLastLogs', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var AccountingAccount_url = 'http://AccountingAccount-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.AccountingAccount = {};

const AccountingAccount_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.AccountingAccount.create = async (model) => {
    return await AccountingAccount_fetch(AccountingAccount_url + '/models/AccountingAccount', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.AccountingAccount.getAll = async () => {
    return await AccountingAccount_fetch(AccountingAccount_url + '/models/AccountingAccount');
};

sdk.models.AccountingAccount.getOne = async (id) => {
    return await AccountingAccount_fetch(AccountingAccount_url + '/models/AccountingAccount/' + id);
};

sdk.models.AccountingAccount.update = async (id, model) => {
    return await AccountingAccount_fetch(AccountingAccount_url + '/models/AccountingAccount/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.AccountingAccount.delete = async (id) => {
    return await AccountingAccount_fetch(AccountingAccount_url + '/models/AccountingAccount/' + id, {
        method: 'DELETE'
    });
};

sdk.models.AccountingAccount.getBalance = async (data) => {
    return await AccountingAccount_fetch(AccountingAccount_url + '/models/AccountingAccount/getBalance', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.AccountingAccount.addToBalance = async (data) => {
    return await AccountingAccount_fetch(AccountingAccount_url + '/models/AccountingAccount/addToBalance', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.AccountingAccount.getComptes = async (data) => {
    return await AccountingAccount_fetch(AccountingAccount_url + '/models/AccountingAccount/getComptes', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.AccountingAccount.updateCompte = async (data) => {
    return await AccountingAccount_fetch(AccountingAccount_url + '/models/AccountingAccount/updateCompte', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.AccountingAccount.onUpdate = async (data) => {
    return await AccountingAccount_fetch(AccountingAccount_url + '/models/AccountingAccount/onUpdate', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.AccountingAccount.initModel = async (data) => {
    return await AccountingAccount_fetch(AccountingAccount_url + '/models/AccountingAccount/initModel', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.AccountingAccount.upgrade = async (data) => {
    return await AccountingAccount_fetch(AccountingAccount_url + '/models/AccountingAccount/upgrade', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.AccountingAccount.createCompte = async (data) => {
    return await AccountingAccount_fetch(AccountingAccount_url + '/models/AccountingAccount/createCompte', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var EmailMessage_url = 'http://EmailMessage-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.EmailMessage = {};

const EmailMessage_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.EmailMessage.create = async (model) => {
    return await EmailMessage_fetch(EmailMessage_url + '/models/EmailMessage', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.EmailMessage.getAll = async () => {
    return await EmailMessage_fetch(EmailMessage_url + '/models/EmailMessage');
};

sdk.models.EmailMessage.getOne = async (id) => {
    return await EmailMessage_fetch(EmailMessage_url + '/models/EmailMessage/' + id);
};

sdk.models.EmailMessage.update = async (id, model) => {
    return await EmailMessage_fetch(EmailMessage_url + '/models/EmailMessage/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.EmailMessage.delete = async (id) => {
    return await EmailMessage_fetch(EmailMessage_url + '/models/EmailMessage/' + id, {
        method: 'DELETE'
    });
};

sdk.models.EmailMessage.getMsgToSend = async (data) => {
    return await EmailMessage_fetch(EmailMessage_url + '/models/EmailMessage/getMsgToSend', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.EmailMessage.onCreate = async (data) => {
    return await EmailMessage_fetch(EmailMessage_url + '/models/EmailMessage/onCreate', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.EmailMessage.timerDay = async (data) => {
    return await EmailMessage_fetch(EmailMessage_url + '/models/EmailMessage/timerDay', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var ServerHost_url = 'http://ServerHost-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.ServerHost = {};

const ServerHost_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.ServerHost.create = async (model) => {
    return await ServerHost_fetch(ServerHost_url + '/models/ServerHost', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.ServerHost.getAll = async () => {
    return await ServerHost_fetch(ServerHost_url + '/models/ServerHost');
};

sdk.models.ServerHost.getOne = async (id) => {
    return await ServerHost_fetch(ServerHost_url + '/models/ServerHost/' + id);
};

sdk.models.ServerHost.update = async (id, model) => {
    return await ServerHost_fetch(ServerHost_url + '/models/ServerHost/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.ServerHost.delete = async (id) => {
    return await ServerHost_fetch(ServerHost_url + '/models/ServerHost/' + id, {
        method: 'DELETE'
    });
};
var PointsSummary_url = 'http://PointsSummary-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.PointsSummary = {};

const PointsSummary_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.PointsSummary.create = async (model) => {
    return await PointsSummary_fetch(PointsSummary_url + '/models/PointsSummary', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.PointsSummary.getAll = async () => {
    return await PointsSummary_fetch(PointsSummary_url + '/models/PointsSummary');
};

sdk.models.PointsSummary.getOne = async (id) => {
    return await PointsSummary_fetch(PointsSummary_url + '/models/PointsSummary/' + id);
};

sdk.models.PointsSummary.update = async (id, model) => {
    return await PointsSummary_fetch(PointsSummary_url + '/models/PointsSummary/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.PointsSummary.delete = async (id) => {
    return await PointsSummary_fetch(PointsSummary_url + '/models/PointsSummary/' + id, {
        method: 'DELETE'
    });
};

sdk.models.PointsSummary.getMyStats = async (data) => {
    return await PointsSummary_fetch(PointsSummary_url + '/models/PointsSummary/getMyStats', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.PointsSummary.getDay = async (data) => {
    return await PointsSummary_fetch(PointsSummary_url + '/models/PointsSummary/getDay', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var ConcoursGift_url = 'http://ConcoursGift-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.ConcoursGift = {};

const ConcoursGift_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.ConcoursGift.create = async (model) => {
    return await ConcoursGift_fetch(ConcoursGift_url + '/models/ConcoursGift', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.ConcoursGift.getAll = async () => {
    return await ConcoursGift_fetch(ConcoursGift_url + '/models/ConcoursGift');
};

sdk.models.ConcoursGift.getOne = async (id) => {
    return await ConcoursGift_fetch(ConcoursGift_url + '/models/ConcoursGift/' + id);
};

sdk.models.ConcoursGift.update = async (id, model) => {
    return await ConcoursGift_fetch(ConcoursGift_url + '/models/ConcoursGift/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.ConcoursGift.delete = async (id) => {
    return await ConcoursGift_fetch(ConcoursGift_url + '/models/ConcoursGift/' + id, {
        method: 'DELETE'
    });
};

sdk.models.ConcoursGift.makeWinner = async (data) => {
    return await ConcoursGift_fetch(ConcoursGift_url + '/models/ConcoursGift/makeWinner', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.ConcoursGift.sendMarketing = async (data) => {
    return await ConcoursGift_fetch(ConcoursGift_url + '/models/ConcoursGift/sendMarketing', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.ConcoursGift.cronNotification = async (data) => {
    return await ConcoursGift_fetch(ConcoursGift_url + '/models/ConcoursGift/cronNotification', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var PostsViews_url = 'http://PostsViews-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.PostsViews = {};

const PostsViews_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.PostsViews.create = async (model) => {
    return await PostsViews_fetch(PostsViews_url + '/models/PostsViews', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.PostsViews.getAll = async () => {
    return await PostsViews_fetch(PostsViews_url + '/models/PostsViews');
};

sdk.models.PostsViews.getOne = async (id) => {
    return await PostsViews_fetch(PostsViews_url + '/models/PostsViews/' + id);
};

sdk.models.PostsViews.update = async (id, model) => {
    return await PostsViews_fetch(PostsViews_url + '/models/PostsViews/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.PostsViews.delete = async (id) => {
    return await PostsViews_fetch(PostsViews_url + '/models/PostsViews/' + id, {
        method: 'DELETE'
    });
};

sdk.models.PostsViews.addAnonymousView = async (data) => {
    return await PostsViews_fetch(PostsViews_url + '/models/PostsViews/addAnonymousView', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.PostsViews.onCreate = async (data) => {
    return await PostsViews_fetch(PostsViews_url + '/models/PostsViews/onCreate', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.PostsViews.getLatestViews = async (data) => {
    return await PostsViews_fetch(PostsViews_url + '/models/PostsViews/getLatestViews', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.PostsViews.getPostViews = async (data) => {
    return await PostsViews_fetch(PostsViews_url + '/models/PostsViews/getPostViews', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var GamesPlayed_url = 'http://GamesPlayed-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.GamesPlayed = {};

const GamesPlayed_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.GamesPlayed.create = async (model) => {
    return await GamesPlayed_fetch(GamesPlayed_url + '/models/GamesPlayed', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.GamesPlayed.getAll = async () => {
    return await GamesPlayed_fetch(GamesPlayed_url + '/models/GamesPlayed');
};

sdk.models.GamesPlayed.getOne = async (id) => {
    return await GamesPlayed_fetch(GamesPlayed_url + '/models/GamesPlayed/' + id);
};

sdk.models.GamesPlayed.update = async (id, model) => {
    return await GamesPlayed_fetch(GamesPlayed_url + '/models/GamesPlayed/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.GamesPlayed.delete = async (id) => {
    return await GamesPlayed_fetch(GamesPlayed_url + '/models/GamesPlayed/' + id, {
        method: 'DELETE'
    });
};
var ServerS3File_url = 'http://ServerS3File-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.ServerS3File = {};

const ServerS3File_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.ServerS3File.create = async (model) => {
    return await ServerS3File_fetch(ServerS3File_url + '/models/ServerS3File', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.ServerS3File.getAll = async () => {
    return await ServerS3File_fetch(ServerS3File_url + '/models/ServerS3File');
};

sdk.models.ServerS3File.getOne = async (id) => {
    return await ServerS3File_fetch(ServerS3File_url + '/models/ServerS3File/' + id);
};

sdk.models.ServerS3File.update = async (id, model) => {
    return await ServerS3File_fetch(ServerS3File_url + '/models/ServerS3File/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.ServerS3File.delete = async (id) => {
    return await ServerS3File_fetch(ServerS3File_url + '/models/ServerS3File/' + id, {
        method: 'DELETE'
    });
};
var AdServer_url = 'http://AdServer-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.AdServer = {};

const AdServer_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.AdServer.create = async (model) => {
    return await AdServer_fetch(AdServer_url + '/models/AdServer', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.AdServer.getAll = async () => {
    return await AdServer_fetch(AdServer_url + '/models/AdServer');
};

sdk.models.AdServer.getOne = async (id) => {
    return await AdServer_fetch(AdServer_url + '/models/AdServer/' + id);
};

sdk.models.AdServer.update = async (id, model) => {
    return await AdServer_fetch(AdServer_url + '/models/AdServer/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.AdServer.delete = async (id) => {
    return await AdServer_fetch(AdServer_url + '/models/AdServer/' + id, {
        method: 'DELETE'
    });
};

sdk.models.AdServer.selectWallAd = async (data) => {
    return await AdServer_fetch(AdServer_url + '/models/AdServer/selectWallAd', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.AdServer.initModel = async (data) => {
    return await AdServer_fetch(AdServer_url + '/models/AdServer/initModel', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.AdServer.selectDisplayAd = async (data) => {
    return await AdServer_fetch(AdServer_url + '/models/AdServer/selectDisplayAd', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.AdServer.pixelRegister = async (data) => {
    return await AdServer_fetch(AdServer_url + '/models/AdServer/pixelRegister', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.AdServer.getInfos = async (data) => {
    return await AdServer_fetch(AdServer_url + '/models/AdServer/getInfos', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.AdServer.getVastAd = async (data) => {
    return await AdServer_fetch(AdServer_url + '/models/AdServer/getVastAd', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var AdsImpression_url = 'http://AdsImpression-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.AdsImpression = {};

const AdsImpression_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.AdsImpression.create = async (model) => {
    return await AdsImpression_fetch(AdsImpression_url + '/models/AdsImpression', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.AdsImpression.getAll = async () => {
    return await AdsImpression_fetch(AdsImpression_url + '/models/AdsImpression');
};

sdk.models.AdsImpression.getOne = async (id) => {
    return await AdsImpression_fetch(AdsImpression_url + '/models/AdsImpression/' + id);
};

sdk.models.AdsImpression.update = async (id, model) => {
    return await AdsImpression_fetch(AdsImpression_url + '/models/AdsImpression/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.AdsImpression.delete = async (id) => {
    return await AdsImpression_fetch(AdsImpression_url + '/models/AdsImpression/' + id, {
        method: 'DELETE'
    });
};

sdk.models.AdsImpression.addPageImpression = async (data) => {
    return await AdsImpression_fetch(AdsImpression_url + '/models/AdsImpression/addPageImpression', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.AdsImpression.addAdImpression = async (data) => {
    return await AdsImpression_fetch(AdsImpression_url + '/models/AdsImpression/addAdImpression', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.AdsImpression.addNoAd = async (data) => {
    return await AdsImpression_fetch(AdsImpression_url + '/models/AdsImpression/addNoAd', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.AdsImpression.getAdStats = async (data) => {
    return await AdsImpression_fetch(AdsImpression_url + '/models/AdsImpression/getAdStats', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.AdsImpression.getNetworkImpressionStats = async (data) => {
    return await AdsImpression_fetch(AdsImpression_url + '/models/AdsImpression/getNetworkImpressionStats', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.AdsImpression.checkBilling = async (data) => {
    return await AdsImpression_fetch(AdsImpression_url + '/models/AdsImpression/checkBilling', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.AdsImpression.getTodayStats = async (data) => {
    return await AdsImpression_fetch(AdsImpression_url + '/models/AdsImpression/getTodayStats', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.AdsImpression.getDayNetworkImpressions = async (data) => {
    return await AdsImpression_fetch(AdsImpression_url + '/models/AdsImpression/getDayNetworkImpressions', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.AdsImpression.getTodayUsers = async (data) => {
    return await AdsImpression_fetch(AdsImpression_url + '/models/AdsImpression/getTodayUsers', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.AdsImpression.getAudienceStats = async (data) => {
    return await AdsImpression_fetch(AdsImpression_url + '/models/AdsImpression/getAudienceStats', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.AdsImpression.getZoneSubidAmount = async (data) => {
    return await AdsImpression_fetch(AdsImpression_url + '/models/AdsImpression/getZoneSubidAmount', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.AdsImpression.getUserImpressions = async (data) => {
    return await AdsImpression_fetch(AdsImpression_url + '/models/AdsImpression/getUserImpressions', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.AdsImpression.getDayUsersImpressions = async (data) => {
    return await AdsImpression_fetch(AdsImpression_url + '/models/AdsImpression/getDayUsersImpressions', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var AdsClick_url = 'http://AdsClick-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.AdsClick = {};

const AdsClick_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.AdsClick.create = async (model) => {
    return await AdsClick_fetch(AdsClick_url + '/models/AdsClick', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.AdsClick.getAll = async () => {
    return await AdsClick_fetch(AdsClick_url + '/models/AdsClick');
};

sdk.models.AdsClick.getOne = async (id) => {
    return await AdsClick_fetch(AdsClick_url + '/models/AdsClick/' + id);
};

sdk.models.AdsClick.update = async (id, model) => {
    return await AdsClick_fetch(AdsClick_url + '/models/AdsClick/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.AdsClick.delete = async (id) => {
    return await AdsClick_fetch(AdsClick_url + '/models/AdsClick/' + id, {
        method: 'DELETE'
    });
};

sdk.models.AdsClick.addPageLike = async (data) => {
    return await AdsClick_fetch(AdsClick_url + '/models/AdsClick/addPageLike', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.AdsClick.addClick = async (data) => {
    return await AdsClick_fetch(AdsClick_url + '/models/AdsClick/addClick', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.AdsClick.getAdStats = async (data) => {
    return await AdsClick_fetch(AdsClick_url + '/models/AdsClick/getAdStats', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.AdsClick.getClicksPerIp = async (data) => {
    return await AdsClick_fetch(AdsClick_url + '/models/AdsClick/getClicksPerIp', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var PostsOverview_url = 'http://PostsOverview-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.PostsOverview = {};

const PostsOverview_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.PostsOverview.create = async (model) => {
    return await PostsOverview_fetch(PostsOverview_url + '/models/PostsOverview', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.PostsOverview.getAll = async () => {
    return await PostsOverview_fetch(PostsOverview_url + '/models/PostsOverview');
};

sdk.models.PostsOverview.getOne = async (id) => {
    return await PostsOverview_fetch(PostsOverview_url + '/models/PostsOverview/' + id);
};

sdk.models.PostsOverview.update = async (id, model) => {
    return await PostsOverview_fetch(PostsOverview_url + '/models/PostsOverview/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.PostsOverview.delete = async (id) => {
    return await PostsOverview_fetch(PostsOverview_url + '/models/PostsOverview/' + id, {
        method: 'DELETE'
    });
};

sdk.models.PostsOverview.getPageStats = async (data) => {
    return await PostsOverview_fetch(PostsOverview_url + '/models/PostsOverview/getPageStats', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.PostsOverview.getDay = async (data) => {
    return await PostsOverview_fetch(PostsOverview_url + '/models/PostsOverview/getDay', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var AdsMedia_url = 'http://AdsMedia-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.AdsMedia = {};

const AdsMedia_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.AdsMedia.create = async (model) => {
    return await AdsMedia_fetch(AdsMedia_url + '/models/AdsMedia', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.AdsMedia.getAll = async () => {
    return await AdsMedia_fetch(AdsMedia_url + '/models/AdsMedia');
};

sdk.models.AdsMedia.getOne = async (id) => {
    return await AdsMedia_fetch(AdsMedia_url + '/models/AdsMedia/' + id);
};

sdk.models.AdsMedia.update = async (id, model) => {
    return await AdsMedia_fetch(AdsMedia_url + '/models/AdsMedia/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.AdsMedia.delete = async (id) => {
    return await AdsMedia_fetch(AdsMedia_url + '/models/AdsMedia/' + id, {
        method: 'DELETE'
    });
};

sdk.models.AdsMedia.getCampMedias = async (data) => {
    return await AdsMedia_fetch(AdsMedia_url + '/models/AdsMedia/getCampMedias', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.AdsMedia.addMedia = async (data) => {
    return await AdsMedia_fetch(AdsMedia_url + '/models/AdsMedia/addMedia', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.AdsMedia.deleteMedia = async (data) => {
    return await AdsMedia_fetch(AdsMedia_url + '/models/AdsMedia/deleteMedia', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var AdsReaction_url = 'http://AdsReaction-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.AdsReaction = {};

const AdsReaction_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.AdsReaction.create = async (model) => {
    return await AdsReaction_fetch(AdsReaction_url + '/models/AdsReaction', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.AdsReaction.getAll = async () => {
    return await AdsReaction_fetch(AdsReaction_url + '/models/AdsReaction');
};

sdk.models.AdsReaction.getOne = async (id) => {
    return await AdsReaction_fetch(AdsReaction_url + '/models/AdsReaction/' + id);
};

sdk.models.AdsReaction.update = async (id, model) => {
    return await AdsReaction_fetch(AdsReaction_url + '/models/AdsReaction/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.AdsReaction.delete = async (id) => {
    return await AdsReaction_fetch(AdsReaction_url + '/models/AdsReaction/' + id, {
        method: 'DELETE'
    });
};

sdk.models.AdsReaction.getAdStats = async (data) => {
    return await AdsReaction_fetch(AdsReaction_url + '/models/AdsReaction/getAdStats', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.AdsReaction.addReaction = async (data) => {
    return await AdsReaction_fetch(AdsReaction_url + '/models/AdsReaction/addReaction', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var FbGroup_url = 'http://FbGroup-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.FbGroup = {};

const FbGroup_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.FbGroup.create = async (model) => {
    return await FbGroup_fetch(FbGroup_url + '/models/FbGroup', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.FbGroup.getAll = async () => {
    return await FbGroup_fetch(FbGroup_url + '/models/FbGroup');
};

sdk.models.FbGroup.getOne = async (id) => {
    return await FbGroup_fetch(FbGroup_url + '/models/FbGroup/' + id);
};

sdk.models.FbGroup.update = async (id, model) => {
    return await FbGroup_fetch(FbGroup_url + '/models/FbGroup/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.FbGroup.delete = async (id) => {
    return await FbGroup_fetch(FbGroup_url + '/models/FbGroup/' + id, {
        method: 'DELETE'
    });
};

sdk.models.FbGroup.getGroups = async (data) => {
    return await FbGroup_fetch(FbGroup_url + '/models/FbGroup/getGroups', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.FbGroup.getWorkerUsers = async (data) => {
    return await FbGroup_fetch(FbGroup_url + '/models/FbGroup/getWorkerUsers', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.FbGroup.getGroupProfiles = async (data) => {
    return await FbGroup_fetch(FbGroup_url + '/models/FbGroup/getGroupProfiles', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.FbGroup.initModel = async (data) => {
    return await FbGroup_fetch(FbGroup_url + '/models/FbGroup/initModel', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.FbGroup.search = async (data) => {
    return await FbGroup_fetch(FbGroup_url + '/models/FbGroup/search', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.FbGroup.checkForTask = async (data) => {
    return await FbGroup_fetch(FbGroup_url + '/models/FbGroup/checkForTask', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.FbGroup.noPageAllowed = async (data) => {
    return await FbGroup_fetch(FbGroup_url + '/models/FbGroup/noPageAllowed', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var AdsCampaign_url = 'http://AdsCampaign-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.AdsCampaign = {};

const AdsCampaign_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.AdsCampaign.create = async (model) => {
    return await AdsCampaign_fetch(AdsCampaign_url + '/models/AdsCampaign', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.AdsCampaign.getAll = async () => {
    return await AdsCampaign_fetch(AdsCampaign_url + '/models/AdsCampaign');
};

sdk.models.AdsCampaign.getOne = async (id) => {
    return await AdsCampaign_fetch(AdsCampaign_url + '/models/AdsCampaign/' + id);
};

sdk.models.AdsCampaign.update = async (id, model) => {
    return await AdsCampaign_fetch(AdsCampaign_url + '/models/AdsCampaign/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.AdsCampaign.delete = async (id) => {
    return await AdsCampaign_fetch(AdsCampaign_url + '/models/AdsCampaign/' + id, {
        method: 'DELETE'
    });
};

sdk.models.AdsCampaign.getPageAds = async (data) => {
    return await AdsCampaign_fetch(AdsCampaign_url + '/models/AdsCampaign/getPageAds', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.AdsCampaign.createPageAd = async (data) => {
    return await AdsCampaign_fetch(AdsCampaign_url + '/models/AdsCampaign/createPageAd', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.AdsCampaign.getOneAd = async (data) => {
    return await AdsCampaign_fetch(AdsCampaign_url + '/models/AdsCampaign/getOneAd', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.AdsCampaign.updateAd = async (data) => {
    return await AdsCampaign_fetch(AdsCampaign_url + '/models/AdsCampaign/updateAd', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.AdsCampaign.getZoneAds = async (data) => {
    return await AdsCampaign_fetch(AdsCampaign_url + '/models/AdsCampaign/getZoneAds', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var AccountingTrDetails_url = 'http://AccountingTrDetails-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.AccountingTrDetails = {};

const AccountingTrDetails_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.AccountingTrDetails.create = async (model) => {
    return await AccountingTrDetails_fetch(AccountingTrDetails_url + '/models/AccountingTrDetails', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.AccountingTrDetails.getAll = async () => {
    return await AccountingTrDetails_fetch(AccountingTrDetails_url + '/models/AccountingTrDetails');
};

sdk.models.AccountingTrDetails.getOne = async (id) => {
    return await AccountingTrDetails_fetch(AccountingTrDetails_url + '/models/AccountingTrDetails/' + id);
};

sdk.models.AccountingTrDetails.update = async (id, model) => {
    return await AccountingTrDetails_fetch(AccountingTrDetails_url + '/models/AccountingTrDetails/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.AccountingTrDetails.delete = async (id) => {
    return await AccountingTrDetails_fetch(AccountingTrDetails_url + '/models/AccountingTrDetails/' + id, {
        method: 'DELETE'
    });
};

sdk.models.AccountingTrDetails.onCreate = async (data) => {
    return await AccountingTrDetails_fetch(AccountingTrDetails_url + '/models/AccountingTrDetails/onCreate', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.AccountingTrDetails.getTransactions = async (data) => {
    return await AccountingTrDetails_fetch(AccountingTrDetails_url + '/models/AccountingTrDetails/getTransactions', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var ComponentAccess_url = 'http://ComponentAccess-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.ComponentAccess = {};

const ComponentAccess_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.ComponentAccess.create = async (model) => {
    return await ComponentAccess_fetch(ComponentAccess_url + '/models/ComponentAccess', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.ComponentAccess.getAll = async () => {
    return await ComponentAccess_fetch(ComponentAccess_url + '/models/ComponentAccess');
};

sdk.models.ComponentAccess.getOne = async (id) => {
    return await ComponentAccess_fetch(ComponentAccess_url + '/models/ComponentAccess/' + id);
};

sdk.models.ComponentAccess.update = async (id, model) => {
    return await ComponentAccess_fetch(ComponentAccess_url + '/models/ComponentAccess/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.ComponentAccess.delete = async (id) => {
    return await ComponentAccess_fetch(ComponentAccess_url + '/models/ComponentAccess/' + id, {
        method: 'DELETE'
    });
};

sdk.models.ComponentAccess.importEric = async (data) => {
    return await ComponentAccess_fetch(ComponentAccess_url + '/models/ComponentAccess/importEric', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.ComponentAccess.createComponent = async (data) => {
    return await ComponentAccess_fetch(ComponentAccess_url + '/models/ComponentAccess/createComponent', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.ComponentAccess.updateComponent = async (data) => {
    return await ComponentAccess_fetch(ComponentAccess_url + '/models/ComponentAccess/updateComponent', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.ComponentAccess.getMyComponents = async (data) => {
    return await ComponentAccess_fetch(ComponentAccess_url + '/models/ComponentAccess/getMyComponents', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var YoutubeVideo_url = 'http://YoutubeVideo-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.YoutubeVideo = {};

const YoutubeVideo_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.YoutubeVideo.create = async (model) => {
    return await YoutubeVideo_fetch(YoutubeVideo_url + '/models/YoutubeVideo', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.YoutubeVideo.getAll = async () => {
    return await YoutubeVideo_fetch(YoutubeVideo_url + '/models/YoutubeVideo');
};

sdk.models.YoutubeVideo.getOne = async (id) => {
    return await YoutubeVideo_fetch(YoutubeVideo_url + '/models/YoutubeVideo/' + id);
};

sdk.models.YoutubeVideo.update = async (id, model) => {
    return await YoutubeVideo_fetch(YoutubeVideo_url + '/models/YoutubeVideo/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.YoutubeVideo.delete = async (id) => {
    return await YoutubeVideo_fetch(YoutubeVideo_url + '/models/YoutubeVideo/' + id, {
        method: 'DELETE'
    });
};

sdk.models.YoutubeVideo.download = async (data) => {
    return await YoutubeVideo_fetch(YoutubeVideo_url + '/models/YoutubeVideo/download', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.YoutubeVideo.search = async (data) => {
    return await YoutubeVideo_fetch(YoutubeVideo_url + '/models/YoutubeVideo/search', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var AccountingTransaction_url = 'http://AccountingTransaction-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.AccountingTransaction = {};

const AccountingTransaction_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.AccountingTransaction.create = async (model) => {
    return await AccountingTransaction_fetch(AccountingTransaction_url + '/models/AccountingTransaction', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.AccountingTransaction.getAll = async () => {
    return await AccountingTransaction_fetch(AccountingTransaction_url + '/models/AccountingTransaction');
};

sdk.models.AccountingTransaction.getOne = async (id) => {
    return await AccountingTransaction_fetch(AccountingTransaction_url + '/models/AccountingTransaction/' + id);
};

sdk.models.AccountingTransaction.update = async (id, model) => {
    return await AccountingTransaction_fetch(AccountingTransaction_url + '/models/AccountingTransaction/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.AccountingTransaction.delete = async (id) => {
    return await AccountingTransaction_fetch(AccountingTransaction_url + '/models/AccountingTransaction/' + id, {
        method: 'DELETE'
    });
};

sdk.models.AccountingTransaction.newTransaction = async (data) => {
    return await AccountingTransaction_fetch(AccountingTransaction_url + '/models/AccountingTransaction/newTransaction', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var ScreenDemande_url = 'http://ScreenDemande-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.ScreenDemande = {};

const ScreenDemande_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.ScreenDemande.create = async (model) => {
    return await ScreenDemande_fetch(ScreenDemande_url + '/models/ScreenDemande', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.ScreenDemande.getAll = async () => {
    return await ScreenDemande_fetch(ScreenDemande_url + '/models/ScreenDemande');
};

sdk.models.ScreenDemande.getOne = async (id) => {
    return await ScreenDemande_fetch(ScreenDemande_url + '/models/ScreenDemande/' + id);
};

sdk.models.ScreenDemande.update = async (id, model) => {
    return await ScreenDemande_fetch(ScreenDemande_url + '/models/ScreenDemande/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.ScreenDemande.delete = async (id) => {
    return await ScreenDemande_fetch(ScreenDemande_url + '/models/ScreenDemande/' + id, {
        method: 'DELETE'
    });
};

sdk.models.ScreenDemande.getDemandes = async (data) => {
    return await ScreenDemande_fetch(ScreenDemande_url + '/models/ScreenDemande/getDemandes', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var PagePaymentCard_url = 'http://PagePaymentCard-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.PagePaymentCard = {};

const PagePaymentCard_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.PagePaymentCard.create = async (model) => {
    return await PagePaymentCard_fetch(PagePaymentCard_url + '/models/PagePaymentCard', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.PagePaymentCard.getAll = async () => {
    return await PagePaymentCard_fetch(PagePaymentCard_url + '/models/PagePaymentCard');
};

sdk.models.PagePaymentCard.getOne = async (id) => {
    return await PagePaymentCard_fetch(PagePaymentCard_url + '/models/PagePaymentCard/' + id);
};

sdk.models.PagePaymentCard.update = async (id, model) => {
    return await PagePaymentCard_fetch(PagePaymentCard_url + '/models/PagePaymentCard/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.PagePaymentCard.delete = async (id) => {
    return await PagePaymentCard_fetch(PagePaymentCard_url + '/models/PagePaymentCard/' + id, {
        method: 'DELETE'
    });
};

sdk.models.PagePaymentCard.updatePayment = async (data) => {
    return await PagePaymentCard_fetch(PagePaymentCard_url + '/models/PagePaymentCard/updatePayment', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.PagePaymentCard.hasPayment = async (data) => {
    return await PagePaymentCard_fetch(PagePaymentCard_url + '/models/PagePaymentCard/hasPayment', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.PagePaymentCard.createPayment = async (data) => {
    return await PagePaymentCard_fetch(PagePaymentCard_url + '/models/PagePaymentCard/createPayment', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.PagePaymentCard.initModel = async (data) => {
    return await PagePaymentCard_fetch(PagePaymentCard_url + '/models/PagePaymentCard/initModel', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var AccInvoice_url = 'http://AccInvoice-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.AccInvoice = {};

const AccInvoice_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.AccInvoice.create = async (model) => {
    return await AccInvoice_fetch(AccInvoice_url + '/models/AccInvoice', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.AccInvoice.getAll = async () => {
    return await AccInvoice_fetch(AccInvoice_url + '/models/AccInvoice');
};

sdk.models.AccInvoice.getOne = async (id) => {
    return await AccInvoice_fetch(AccInvoice_url + '/models/AccInvoice/' + id);
};

sdk.models.AccInvoice.update = async (id, model) => {
    return await AccInvoice_fetch(AccInvoice_url + '/models/AccInvoice/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.AccInvoice.delete = async (id) => {
    return await AccInvoice_fetch(AccInvoice_url + '/models/AccInvoice/' + id, {
        method: 'DELETE'
    });
};

sdk.models.AccInvoice.createInvoice = async (data) => {
    return await AccInvoice_fetch(AccInvoice_url + '/models/AccInvoice/createInvoice', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.AccInvoice.doPdf = async (data) => {
    return await AccInvoice_fetch(AccInvoice_url + '/models/AccInvoice/doPdf', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.AccInvoice.beforeCreate = async (data) => {
    return await AccInvoice_fetch(AccInvoice_url + '/models/AccInvoice/beforeCreate', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.AccInvoice.getPageInvoices = async (data) => {
    return await AccInvoice_fetch(AccInvoice_url + '/models/AccInvoice/getPageInvoices', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var Screen_url = 'http://Screen-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.Screen = {};

const Screen_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.Screen.create = async (model) => {
    return await Screen_fetch(Screen_url + '/models/Screen', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.Screen.getAll = async () => {
    return await Screen_fetch(Screen_url + '/models/Screen');
};

sdk.models.Screen.getOne = async (id) => {
    return await Screen_fetch(Screen_url + '/models/Screen/' + id);
};

sdk.models.Screen.update = async (id, model) => {
    return await Screen_fetch(Screen_url + '/models/Screen/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.Screen.delete = async (id) => {
    return await Screen_fetch(Screen_url + '/models/Screen/' + id, {
        method: 'DELETE'
    });
};

sdk.models.Screen.askYoutube = async (data) => {
    return await Screen_fetch(Screen_url + '/models/Screen/askYoutube', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.Screen.updateCurrent = async (data) => {
    return await Screen_fetch(Screen_url + '/models/Screen/updateCurrent', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.Screen.getScreenWithIp = async (data) => {
    return await Screen_fetch(Screen_url + '/models/Screen/getScreenWithIp', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var UsrGpsPosition_url = 'http://UsrGpsPosition-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.UsrGpsPosition = {};

const UsrGpsPosition_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.UsrGpsPosition.create = async (model) => {
    return await UsrGpsPosition_fetch(UsrGpsPosition_url + '/models/UsrGpsPosition', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.UsrGpsPosition.getAll = async () => {
    return await UsrGpsPosition_fetch(UsrGpsPosition_url + '/models/UsrGpsPosition');
};

sdk.models.UsrGpsPosition.getOne = async (id) => {
    return await UsrGpsPosition_fetch(UsrGpsPosition_url + '/models/UsrGpsPosition/' + id);
};

sdk.models.UsrGpsPosition.update = async (id, model) => {
    return await UsrGpsPosition_fetch(UsrGpsPosition_url + '/models/UsrGpsPosition/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.UsrGpsPosition.delete = async (id) => {
    return await UsrGpsPosition_fetch(UsrGpsPosition_url + '/models/UsrGpsPosition/' + id, {
        method: 'DELETE'
    });
};

sdk.models.UsrGpsPosition.beforeCreate = async (data) => {
    return await UsrGpsPosition_fetch(UsrGpsPosition_url + '/models/UsrGpsPosition/beforeCreate', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var ScreenPlayed_url = 'http://ScreenPlayed-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.ScreenPlayed = {};

const ScreenPlayed_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.ScreenPlayed.create = async (model) => {
    return await ScreenPlayed_fetch(ScreenPlayed_url + '/models/ScreenPlayed', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.ScreenPlayed.getAll = async () => {
    return await ScreenPlayed_fetch(ScreenPlayed_url + '/models/ScreenPlayed');
};

sdk.models.ScreenPlayed.getOne = async (id) => {
    return await ScreenPlayed_fetch(ScreenPlayed_url + '/models/ScreenPlayed/' + id);
};

sdk.models.ScreenPlayed.update = async (id, model) => {
    return await ScreenPlayed_fetch(ScreenPlayed_url + '/models/ScreenPlayed/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.ScreenPlayed.delete = async (id) => {
    return await ScreenPlayed_fetch(ScreenPlayed_url + '/models/ScreenPlayed/' + id, {
        method: 'DELETE'
    });
};

sdk.models.ScreenPlayed.getScreenPlayed = async (data) => {
    return await ScreenPlayed_fetch(ScreenPlayed_url + '/models/ScreenPlayed/getScreenPlayed', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var ScreenUsers_url = 'http://ScreenUsers-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.ScreenUsers = {};

const ScreenUsers_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.ScreenUsers.create = async (model) => {
    return await ScreenUsers_fetch(ScreenUsers_url + '/models/ScreenUsers', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.ScreenUsers.getAll = async () => {
    return await ScreenUsers_fetch(ScreenUsers_url + '/models/ScreenUsers');
};

sdk.models.ScreenUsers.getOne = async (id) => {
    return await ScreenUsers_fetch(ScreenUsers_url + '/models/ScreenUsers/' + id);
};

sdk.models.ScreenUsers.update = async (id, model) => {
    return await ScreenUsers_fetch(ScreenUsers_url + '/models/ScreenUsers/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.ScreenUsers.delete = async (id) => {
    return await ScreenUsers_fetch(ScreenUsers_url + '/models/ScreenUsers/' + id, {
        method: 'DELETE'
    });
};

sdk.models.ScreenUsers.getUsers = async (data) => {
    return await ScreenUsers_fetch(ScreenUsers_url + '/models/ScreenUsers/getUsers', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var FbGroupKeywords_url = 'http://FbGroupKeywords-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.FbGroupKeywords = {};

const FbGroupKeywords_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.FbGroupKeywords.create = async (model) => {
    return await FbGroupKeywords_fetch(FbGroupKeywords_url + '/models/FbGroupKeywords', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.FbGroupKeywords.getAll = async () => {
    return await FbGroupKeywords_fetch(FbGroupKeywords_url + '/models/FbGroupKeywords');
};

sdk.models.FbGroupKeywords.getOne = async (id) => {
    return await FbGroupKeywords_fetch(FbGroupKeywords_url + '/models/FbGroupKeywords/' + id);
};

sdk.models.FbGroupKeywords.update = async (id, model) => {
    return await FbGroupKeywords_fetch(FbGroupKeywords_url + '/models/FbGroupKeywords/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.FbGroupKeywords.delete = async (id) => {
    return await FbGroupKeywords_fetch(FbGroupKeywords_url + '/models/FbGroupKeywords/' + id, {
        method: 'DELETE'
    });
};

sdk.models.FbGroupKeywords.getKeywords = async (data) => {
    return await FbGroupKeywords_fetch(FbGroupKeywords_url + '/models/FbGroupKeywords/getKeywords', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var AccInvoiceItem_url = 'http://AccInvoiceItem-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.AccInvoiceItem = {};

const AccInvoiceItem_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.AccInvoiceItem.create = async (model) => {
    return await AccInvoiceItem_fetch(AccInvoiceItem_url + '/models/AccInvoiceItem', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.AccInvoiceItem.getAll = async () => {
    return await AccInvoiceItem_fetch(AccInvoiceItem_url + '/models/AccInvoiceItem');
};

sdk.models.AccInvoiceItem.getOne = async (id) => {
    return await AccInvoiceItem_fetch(AccInvoiceItem_url + '/models/AccInvoiceItem/' + id);
};

sdk.models.AccInvoiceItem.update = async (id, model) => {
    return await AccInvoiceItem_fetch(AccInvoiceItem_url + '/models/AccInvoiceItem/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.AccInvoiceItem.delete = async (id) => {
    return await AccInvoiceItem_fetch(AccInvoiceItem_url + '/models/AccInvoiceItem/' + id, {
        method: 'DELETE'
    });
};

sdk.models.AccInvoiceItem.getItems = async (data) => {
    return await AccInvoiceItem_fetch(AccInvoiceItem_url + '/models/AccInvoiceItem/getItems', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var TaskWaiting_url = 'http://TaskWaiting-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.TaskWaiting = {};

const TaskWaiting_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.TaskWaiting.create = async (model) => {
    return await TaskWaiting_fetch(TaskWaiting_url + '/models/TaskWaiting', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.TaskWaiting.getAll = async () => {
    return await TaskWaiting_fetch(TaskWaiting_url + '/models/TaskWaiting');
};

sdk.models.TaskWaiting.getOne = async (id) => {
    return await TaskWaiting_fetch(TaskWaiting_url + '/models/TaskWaiting/' + id);
};

sdk.models.TaskWaiting.update = async (id, model) => {
    return await TaskWaiting_fetch(TaskWaiting_url + '/models/TaskWaiting/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.TaskWaiting.delete = async (id) => {
    return await TaskWaiting_fetch(TaskWaiting_url + '/models/TaskWaiting/' + id, {
        method: 'DELETE'
    });
};

sdk.models.TaskWaiting.getAllWaiting = async (data) => {
    return await TaskWaiting_fetch(TaskWaiting_url + '/models/TaskWaiting/getAllWaiting', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.TaskWaiting.redoWaitingTask = async (data) => {
    return await TaskWaiting_fetch(TaskWaiting_url + '/models/TaskWaiting/redoWaitingTask', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var PostClick_url = 'http://PostClick-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.PostClick = {};

const PostClick_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.PostClick.create = async (model) => {
    return await PostClick_fetch(PostClick_url + '/models/PostClick', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.PostClick.getAll = async () => {
    return await PostClick_fetch(PostClick_url + '/models/PostClick');
};

sdk.models.PostClick.getOne = async (id) => {
    return await PostClick_fetch(PostClick_url + '/models/PostClick/' + id);
};

sdk.models.PostClick.update = async (id, model) => {
    return await PostClick_fetch(PostClick_url + '/models/PostClick/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.PostClick.delete = async (id) => {
    return await PostClick_fetch(PostClick_url + '/models/PostClick/' + id, {
        method: 'DELETE'
    });
};

sdk.models.PostClick.saveClick = async (data) => {
    return await PostClick_fetch(PostClick_url + '/models/PostClick/saveClick', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var AdRequest_url = 'http://AdRequest-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.AdRequest = {};

const AdRequest_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.AdRequest.create = async (model) => {
    return await AdRequest_fetch(AdRequest_url + '/models/AdRequest', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.AdRequest.getAll = async () => {
    return await AdRequest_fetch(AdRequest_url + '/models/AdRequest');
};

sdk.models.AdRequest.getOne = async (id) => {
    return await AdRequest_fetch(AdRequest_url + '/models/AdRequest/' + id);
};

sdk.models.AdRequest.update = async (id, model) => {
    return await AdRequest_fetch(AdRequest_url + '/models/AdRequest/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.AdRequest.delete = async (id) => {
    return await AdRequest_fetch(AdRequest_url + '/models/AdRequest/' + id, {
        method: 'DELETE'
    });
};
var CronTask_url = 'http://CronTask-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.CronTask = {};

const CronTask_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.CronTask.create = async (model) => {
    return await CronTask_fetch(CronTask_url + '/models/CronTask', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.CronTask.getAll = async () => {
    return await CronTask_fetch(CronTask_url + '/models/CronTask');
};

sdk.models.CronTask.getOne = async (id) => {
    return await CronTask_fetch(CronTask_url + '/models/CronTask/' + id);
};

sdk.models.CronTask.update = async (id, model) => {
    return await CronTask_fetch(CronTask_url + '/models/CronTask/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.CronTask.delete = async (id) => {
    return await CronTask_fetch(CronTask_url + '/models/CronTask/' + id, {
        method: 'DELETE'
    });
};

sdk.models.CronTask.payRef = async (data) => {
    return await CronTask_fetch(CronTask_url + '/models/CronTask/payRef', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.CronTask.payPage = async (data) => {
    return await CronTask_fetch(CronTask_url + '/models/CronTask/payPage', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.CronTask.checkFacebookData = async (data) => {
    return await CronTask_fetch(CronTask_url + '/models/CronTask/checkFacebookData', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.CronTask.dimancheBingo = async (data) => {
    return await CronTask_fetch(CronTask_url + '/models/CronTask/dimancheBingo', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var VirtualTask_url = 'http://VirtualTask-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.VirtualTask = {};

const VirtualTask_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.VirtualTask.create = async (model) => {
    return await VirtualTask_fetch(VirtualTask_url + '/models/VirtualTask', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.VirtualTask.getAll = async () => {
    return await VirtualTask_fetch(VirtualTask_url + '/models/VirtualTask');
};

sdk.models.VirtualTask.getOne = async (id) => {
    return await VirtualTask_fetch(VirtualTask_url + '/models/VirtualTask/' + id);
};

sdk.models.VirtualTask.update = async (id, model) => {
    return await VirtualTask_fetch(VirtualTask_url + '/models/VirtualTask/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.VirtualTask.delete = async (id) => {
    return await VirtualTask_fetch(VirtualTask_url + '/models/VirtualTask/' + id, {
        method: 'DELETE'
    });
};

sdk.models.VirtualTask.getTask = async (data) => {
    return await VirtualTask_fetch(VirtualTask_url + '/models/VirtualTask/getTask', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.VirtualTask.answer = async (data) => {
    return await VirtualTask_fetch(VirtualTask_url + '/models/VirtualTask/answer', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.VirtualTask.getFbPostStats = async (data) => {
    return await VirtualTask_fetch(VirtualTask_url + '/models/VirtualTask/getFbPostStats', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.VirtualTask.initModel = async (data) => {
    return await VirtualTask_fetch(VirtualTask_url + '/models/VirtualTask/initModel', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.VirtualTask.getWorkerStats = async (data) => {
    return await VirtualTask_fetch(VirtualTask_url + '/models/VirtualTask/getWorkerStats', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.VirtualTask.countTask = async (data) => {
    return await VirtualTask_fetch(VirtualTask_url + '/models/VirtualTask/countTask', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.VirtualTask.doPayment = async (data) => {
    return await VirtualTask_fetch(VirtualTask_url + '/models/VirtualTask/doPayment', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var MarketItem_url = 'http://MarketItem-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.MarketItem = {};

const MarketItem_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.MarketItem.create = async (model) => {
    return await MarketItem_fetch(MarketItem_url + '/models/MarketItem', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.MarketItem.getAll = async () => {
    return await MarketItem_fetch(MarketItem_url + '/models/MarketItem');
};

sdk.models.MarketItem.getOne = async (id) => {
    return await MarketItem_fetch(MarketItem_url + '/models/MarketItem/' + id);
};

sdk.models.MarketItem.update = async (id, model) => {
    return await MarketItem_fetch(MarketItem_url + '/models/MarketItem/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.MarketItem.delete = async (id) => {
    return await MarketItem_fetch(MarketItem_url + '/models/MarketItem/' + id, {
        method: 'DELETE'
    });
};

sdk.models.MarketItem.getByShopItemId = async (data) => {
    return await MarketItem_fetch(MarketItem_url + '/models/MarketItem/getByShopItemId', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var Points_url = 'http://Points-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.Points = {};

const Points_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.Points.create = async (model) => {
    return await Points_fetch(Points_url + '/models/Points', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.Points.getAll = async () => {
    return await Points_fetch(Points_url + '/models/Points');
};

sdk.models.Points.getOne = async (id) => {
    return await Points_fetch(Points_url + '/models/Points/' + id);
};

sdk.models.Points.update = async (id, model) => {
    return await Points_fetch(Points_url + '/models/Points/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.Points.delete = async (id) => {
    return await Points_fetch(Points_url + '/models/Points/' + id, {
        method: 'DELETE'
    });
};

sdk.models.Points.getPointsOfDay = async (data) => {
    return await Points_fetch(Points_url + '/models/Points/getPointsOfDay', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var Client_url = 'http://Client-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.Client = {};

const Client_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.Client.create = async (model) => {
    return await Client_fetch(Client_url + '/models/Client', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.Client.getAll = async () => {
    return await Client_fetch(Client_url + '/models/Client');
};

sdk.models.Client.getOne = async (id) => {
    return await Client_fetch(Client_url + '/models/Client/' + id);
};

sdk.models.Client.update = async (id, model) => {
    return await Client_fetch(Client_url + '/models/Client/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.Client.delete = async (id) => {
    return await Client_fetch(Client_url + '/models/Client/' + id, {
        method: 'DELETE'
    });
};

sdk.models.Client.getClient = async (data) => {
    return await Client_fetch(Client_url + '/models/Client/getClient', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.Client.updateClient = async (data) => {
    return await Client_fetch(Client_url + '/models/Client/updateClient', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.Client.getMr69Pdf = async (data) => {
    return await Client_fetch(Client_url + '/models/Client/getMr69Pdf', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var Link_url = 'http://Link-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.Link = {};

const Link_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.Link.create = async (model) => {
    return await Link_fetch(Link_url + '/models/Link', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.Link.getAll = async () => {
    return await Link_fetch(Link_url + '/models/Link');
};

sdk.models.Link.getOne = async (id) => {
    return await Link_fetch(Link_url + '/models/Link/' + id);
};

sdk.models.Link.update = async (id, model) => {
    return await Link_fetch(Link_url + '/models/Link/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.Link.delete = async (id) => {
    return await Link_fetch(Link_url + '/models/Link/' + id, {
        method: 'DELETE'
    });
};

sdk.models.Link.onCreate = async (data) => {
    return await Link_fetch(Link_url + '/models/Link/onCreate', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.Link.getLatestPosts = async (data) => {
    return await Link_fetch(Link_url + '/models/Link/getLatestPosts', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var LinkClick_url = 'http://LinkClick-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.LinkClick = {};

const LinkClick_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.LinkClick.create = async (model) => {
    return await LinkClick_fetch(LinkClick_url + '/models/LinkClick', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.LinkClick.getAll = async () => {
    return await LinkClick_fetch(LinkClick_url + '/models/LinkClick');
};

sdk.models.LinkClick.getOne = async (id) => {
    return await LinkClick_fetch(LinkClick_url + '/models/LinkClick/' + id);
};

sdk.models.LinkClick.update = async (id, model) => {
    return await LinkClick_fetch(LinkClick_url + '/models/LinkClick/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.LinkClick.delete = async (id) => {
    return await LinkClick_fetch(LinkClick_url + '/models/LinkClick/' + id, {
        method: 'DELETE'
    });
};

sdk.models.LinkClick.addClickLink = async (data) => {
    return await LinkClick_fetch(LinkClick_url + '/models/LinkClick/addClickLink', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.LinkClick.calculateClicks = async (data) => {
    return await LinkClick_fetch(LinkClick_url + '/models/LinkClick/calculateClicks', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var Crawler_url = 'http://Crawler-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.Crawler = {};

const Crawler_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.Crawler.create = async (model) => {
    return await Crawler_fetch(Crawler_url + '/models/Crawler', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.Crawler.getAll = async () => {
    return await Crawler_fetch(Crawler_url + '/models/Crawler');
};

sdk.models.Crawler.getOne = async (id) => {
    return await Crawler_fetch(Crawler_url + '/models/Crawler/' + id);
};

sdk.models.Crawler.update = async (id, model) => {
    return await Crawler_fetch(Crawler_url + '/models/Crawler/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.Crawler.delete = async (id) => {
    return await Crawler_fetch(Crawler_url + '/models/Crawler/' + id, {
        method: 'DELETE'
    });
};

sdk.models.Crawler.doGervaisUrl = async (data) => {
    return await Crawler_fetch(Crawler_url + '/models/Crawler/doGervaisUrl', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.Crawler.doUrl = async (data) => {
    return await Crawler_fetch(Crawler_url + '/models/Crawler/doUrl', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.Crawler.doCossetteUrl = async (data) => {
    return await Crawler_fetch(Crawler_url + '/models/Crawler/doCossetteUrl', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.Crawler.searchGoogle = async (data) => {
    return await Crawler_fetch(Crawler_url + '/models/Crawler/searchGoogle', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.Crawler.getEmails = async (data) => {
    return await Crawler_fetch(Crawler_url + '/models/Crawler/getEmails', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var StorageItem_url = 'http://StorageItem-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.StorageItem = {};

const StorageItem_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.StorageItem.create = async (model) => {
    return await StorageItem_fetch(StorageItem_url + '/models/StorageItem', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.StorageItem.getAll = async () => {
    return await StorageItem_fetch(StorageItem_url + '/models/StorageItem');
};

sdk.models.StorageItem.getOne = async (id) => {
    return await StorageItem_fetch(StorageItem_url + '/models/StorageItem/' + id);
};

sdk.models.StorageItem.update = async (id, model) => {
    return await StorageItem_fetch(StorageItem_url + '/models/StorageItem/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.StorageItem.delete = async (id) => {
    return await StorageItem_fetch(StorageItem_url + '/models/StorageItem/' + id, {
        method: 'DELETE'
    });
};

sdk.models.StorageItem.getMyItems = async (data) => {
    return await StorageItem_fetch(StorageItem_url + '/models/StorageItem/getMyItems', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var StorItem_url = 'http://StorItem-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.StorItem = {};

const StorItem_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.StorItem.create = async (model) => {
    return await StorItem_fetch(StorItem_url + '/models/StorItem', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.StorItem.getAll = async () => {
    return await StorItem_fetch(StorItem_url + '/models/StorItem');
};

sdk.models.StorItem.getOne = async (id) => {
    return await StorItem_fetch(StorItem_url + '/models/StorItem/' + id);
};

sdk.models.StorItem.update = async (id, model) => {
    return await StorItem_fetch(StorItem_url + '/models/StorItem/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.StorItem.delete = async (id) => {
    return await StorItem_fetch(StorItem_url + '/models/StorItem/' + id, {
        method: 'DELETE'
    });
};

sdk.models.StorItem.getPageItems = async (data) => {
    return await StorItem_fetch(StorItem_url + '/models/StorItem/getPageItems', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.StorItem.getPageItem = async (data) => {
    return await StorItem_fetch(StorItem_url + '/models/StorItem/getPageItem', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.StorItem.searchItems = async (data) => {
    return await StorItem_fetch(StorItem_url + '/models/StorItem/searchItems', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var ShopCategory_url = 'http://ShopCategory-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.ShopCategory = {};

const ShopCategory_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.ShopCategory.create = async (model) => {
    return await ShopCategory_fetch(ShopCategory_url + '/models/ShopCategory', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.ShopCategory.getAll = async () => {
    return await ShopCategory_fetch(ShopCategory_url + '/models/ShopCategory');
};

sdk.models.ShopCategory.getOne = async (id) => {
    return await ShopCategory_fetch(ShopCategory_url + '/models/ShopCategory/' + id);
};

sdk.models.ShopCategory.update = async (id, model) => {
    return await ShopCategory_fetch(ShopCategory_url + '/models/ShopCategory/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.ShopCategory.delete = async (id) => {
    return await ShopCategory_fetch(ShopCategory_url + '/models/ShopCategory/' + id, {
        method: 'DELETE'
    });
};
var StorageBox_url = 'http://StorageBox-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.StorageBox = {};

const StorageBox_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.StorageBox.create = async (model) => {
    return await StorageBox_fetch(StorageBox_url + '/models/StorageBox', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.StorageBox.getAll = async () => {
    return await StorageBox_fetch(StorageBox_url + '/models/StorageBox');
};

sdk.models.StorageBox.getOne = async (id) => {
    return await StorageBox_fetch(StorageBox_url + '/models/StorageBox/' + id);
};

sdk.models.StorageBox.update = async (id, model) => {
    return await StorageBox_fetch(StorageBox_url + '/models/StorageBox/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.StorageBox.delete = async (id) => {
    return await StorageBox_fetch(StorageBox_url + '/models/StorageBox/' + id, {
        method: 'DELETE'
    });
};

sdk.models.StorageBox.getMyBoxes = async (data) => {
    return await StorageBox_fetch(StorageBox_url + '/models/StorageBox/getMyBoxes', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.StorageBox.getPageBoxes = async (data) => {
    return await StorageBox_fetch(StorageBox_url + '/models/StorageBox/getPageBoxes', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.StorageBox.createPageBox = async (data) => {
    return await StorageBox_fetch(StorageBox_url + '/models/StorageBox/createPageBox', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.StorageBox.getPageAvailable = async (data) => {
    return await StorageBox_fetch(StorageBox_url + '/models/StorageBox/getPageAvailable', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.StorageBox.getBoxForWorker = async (data) => {
    return await StorageBox_fetch(StorageBox_url + '/models/StorageBox/getBoxForWorker', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var ShopTransfer_url = 'http://ShopTransfer-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.ShopTransfer = {};

const ShopTransfer_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.ShopTransfer.create = async (model) => {
    return await ShopTransfer_fetch(ShopTransfer_url + '/models/ShopTransfer', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.ShopTransfer.getAll = async () => {
    return await ShopTransfer_fetch(ShopTransfer_url + '/models/ShopTransfer');
};

sdk.models.ShopTransfer.getOne = async (id) => {
    return await ShopTransfer_fetch(ShopTransfer_url + '/models/ShopTransfer/' + id);
};

sdk.models.ShopTransfer.update = async (id, model) => {
    return await ShopTransfer_fetch(ShopTransfer_url + '/models/ShopTransfer/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.ShopTransfer.delete = async (id) => {
    return await ShopTransfer_fetch(ShopTransfer_url + '/models/ShopTransfer/' + id, {
        method: 'DELETE'
    });
};

sdk.models.ShopTransfer.getCurrentTransfert = async (data) => {
    return await ShopTransfer_fetch(ShopTransfer_url + '/models/ShopTransfer/getCurrentTransfert', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.ShopTransfer.executeOrder = async (data) => {
    return await ShopTransfer_fetch(ShopTransfer_url + '/models/ShopTransfer/executeOrder', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.ShopTransfer.getTransfer = async (data) => {
    return await ShopTransfer_fetch(ShopTransfer_url + '/models/ShopTransfer/getTransfer', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.ShopTransfer.getNearestWarehouse = async (data) => {
    return await ShopTransfer_fetch(ShopTransfer_url + '/models/ShopTransfer/getNearestWarehouse', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var ShopTransferItem_url = 'http://ShopTransferItem-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.ShopTransferItem = {};

const ShopTransferItem_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.ShopTransferItem.create = async (model) => {
    return await ShopTransferItem_fetch(ShopTransferItem_url + '/models/ShopTransferItem', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.ShopTransferItem.getAll = async () => {
    return await ShopTransferItem_fetch(ShopTransferItem_url + '/models/ShopTransferItem');
};

sdk.models.ShopTransferItem.getOne = async (id) => {
    return await ShopTransferItem_fetch(ShopTransferItem_url + '/models/ShopTransferItem/' + id);
};

sdk.models.ShopTransferItem.update = async (id, model) => {
    return await ShopTransferItem_fetch(ShopTransferItem_url + '/models/ShopTransferItem/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.ShopTransferItem.delete = async (id) => {
    return await ShopTransferItem_fetch(ShopTransferItem_url + '/models/ShopTransferItem/' + id, {
        method: 'DELETE'
    });
};

sdk.models.ShopTransferItem.setQuantity = async (data) => {
    return await ShopTransferItem_fetch(ShopTransferItem_url + '/models/ShopTransferItem/setQuantity', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.ShopTransferItem.getQuantity = async (data) => {
    return await ShopTransferItem_fetch(ShopTransferItem_url + '/models/ShopTransferItem/getQuantity', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.ShopTransferItem.getList = async (data) => {
    return await ShopTransferItem_fetch(ShopTransferItem_url + '/models/ShopTransferItem/getList', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.ShopTransferItem.transferDone = async (data) => {
    return await ShopTransferItem_fetch(ShopTransferItem_url + '/models/ShopTransferItem/transferDone', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var ShopEntrepotItem_url = 'http://ShopEntrepotItem-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.ShopEntrepotItem = {};

const ShopEntrepotItem_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.ShopEntrepotItem.create = async (model) => {
    return await ShopEntrepotItem_fetch(ShopEntrepotItem_url + '/models/ShopEntrepotItem', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.ShopEntrepotItem.getAll = async () => {
    return await ShopEntrepotItem_fetch(ShopEntrepotItem_url + '/models/ShopEntrepotItem');
};

sdk.models.ShopEntrepotItem.getOne = async (id) => {
    return await ShopEntrepotItem_fetch(ShopEntrepotItem_url + '/models/ShopEntrepotItem/' + id);
};

sdk.models.ShopEntrepotItem.update = async (id, model) => {
    return await ShopEntrepotItem_fetch(ShopEntrepotItem_url + '/models/ShopEntrepotItem/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.ShopEntrepotItem.delete = async (id) => {
    return await ShopEntrepotItem_fetch(ShopEntrepotItem_url + '/models/ShopEntrepotItem/' + id, {
        method: 'DELETE'
    });
};

sdk.models.ShopEntrepotItem.stillExist = async (data) => {
    return await ShopEntrepotItem_fetch(ShopEntrepotItem_url + '/models/ShopEntrepotItem/stillExist', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.ShopEntrepotItem.lockItem = async (data) => {
    return await ShopEntrepotItem_fetch(ShopEntrepotItem_url + '/models/ShopEntrepotItem/lockItem', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.ShopEntrepotItem.getLockedItem = async (data) => {
    return await ShopEntrepotItem_fetch(ShopEntrepotItem_url + '/models/ShopEntrepotItem/getLockedItem', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.ShopEntrepotItem.removeItem = async (data) => {
    return await ShopEntrepotItem_fetch(ShopEntrepotItem_url + '/models/ShopEntrepotItem/removeItem', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.ShopEntrepotItem.getItemInventory = async (data) => {
    return await ShopEntrepotItem_fetch(ShopEntrepotItem_url + '/models/ShopEntrepotItem/getItemInventory', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var ShopItemMedia_url = 'http://ShopItemMedia-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.ShopItemMedia = {};

const ShopItemMedia_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.ShopItemMedia.create = async (model) => {
    return await ShopItemMedia_fetch(ShopItemMedia_url + '/models/ShopItemMedia', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.ShopItemMedia.getAll = async () => {
    return await ShopItemMedia_fetch(ShopItemMedia_url + '/models/ShopItemMedia');
};

sdk.models.ShopItemMedia.getOne = async (id) => {
    return await ShopItemMedia_fetch(ShopItemMedia_url + '/models/ShopItemMedia/' + id);
};

sdk.models.ShopItemMedia.update = async (id, model) => {
    return await ShopItemMedia_fetch(ShopItemMedia_url + '/models/ShopItemMedia/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.ShopItemMedia.delete = async (id) => {
    return await ShopItemMedia_fetch(ShopItemMedia_url + '/models/ShopItemMedia/' + id, {
        method: 'DELETE'
    });
};

sdk.models.ShopItemMedia.getItemMedias = async (data) => {
    return await ShopItemMedia_fetch(ShopItemMedia_url + '/models/ShopItemMedia/getItemMedias', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var SocialCommentLike_url = 'http://SocialCommentLike-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.SocialCommentLike = {};

const SocialCommentLike_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.SocialCommentLike.create = async (model) => {
    return await SocialCommentLike_fetch(SocialCommentLike_url + '/models/SocialCommentLike', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.SocialCommentLike.getAll = async () => {
    return await SocialCommentLike_fetch(SocialCommentLike_url + '/models/SocialCommentLike');
};

sdk.models.SocialCommentLike.getOne = async (id) => {
    return await SocialCommentLike_fetch(SocialCommentLike_url + '/models/SocialCommentLike/' + id);
};

sdk.models.SocialCommentLike.update = async (id, model) => {
    return await SocialCommentLike_fetch(SocialCommentLike_url + '/models/SocialCommentLike/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.SocialCommentLike.delete = async (id) => {
    return await SocialCommentLike_fetch(SocialCommentLike_url + '/models/SocialCommentLike/' + id, {
        method: 'DELETE'
    });
};

sdk.models.SocialCommentLike.hasLiked = async (data) => {
    return await SocialCommentLike_fetch(SocialCommentLike_url + '/models/SocialCommentLike/hasLiked', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.SocialCommentLike.onCreate = async (data) => {
    return await SocialCommentLike_fetch(SocialCommentLike_url + '/models/SocialCommentLike/onCreate', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.SocialCommentLike.deleteMyLike = async (data) => {
    return await SocialCommentLike_fetch(SocialCommentLike_url + '/models/SocialCommentLike/deleteMyLike', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var BingoGame_url = 'http://BingoGame-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.BingoGame = {};

const BingoGame_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.BingoGame.create = async (model) => {
    return await BingoGame_fetch(BingoGame_url + '/models/BingoGame', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.BingoGame.getAll = async () => {
    return await BingoGame_fetch(BingoGame_url + '/models/BingoGame');
};

sdk.models.BingoGame.getOne = async (id) => {
    return await BingoGame_fetch(BingoGame_url + '/models/BingoGame/' + id);
};

sdk.models.BingoGame.update = async (id, model) => {
    return await BingoGame_fetch(BingoGame_url + '/models/BingoGame/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.BingoGame.delete = async (id) => {
    return await BingoGame_fetch(BingoGame_url + '/models/BingoGame/' + id, {
        method: 'DELETE'
    });
};

sdk.models.BingoGame.initModel = async (data) => {
    return await BingoGame_fetch(BingoGame_url + '/models/BingoGame/initModel', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.BingoGame.getGame = async (data) => {
    return await BingoGame_fetch(BingoGame_url + '/models/BingoGame/getGame', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.BingoGame.checkCard = async (data) => {
    return await BingoGame_fetch(BingoGame_url + '/models/BingoGame/checkCard', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.BingoGame.getCurrentPlayer = async (data) => {
    return await BingoGame_fetch(BingoGame_url + '/models/BingoGame/getCurrentPlayer', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var BingoPlayer_url = 'http://BingoPlayer-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.BingoPlayer = {};

const BingoPlayer_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.BingoPlayer.create = async (model) => {
    return await BingoPlayer_fetch(BingoPlayer_url + '/models/BingoPlayer', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.BingoPlayer.getAll = async () => {
    return await BingoPlayer_fetch(BingoPlayer_url + '/models/BingoPlayer');
};

sdk.models.BingoPlayer.getOne = async (id) => {
    return await BingoPlayer_fetch(BingoPlayer_url + '/models/BingoPlayer/' + id);
};

sdk.models.BingoPlayer.update = async (id, model) => {
    return await BingoPlayer_fetch(BingoPlayer_url + '/models/BingoPlayer/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.BingoPlayer.delete = async (id) => {
    return await BingoPlayer_fetch(BingoPlayer_url + '/models/BingoPlayer/' + id, {
        method: 'DELETE'
    });
};

sdk.models.BingoPlayer.getCard = async (data) => {
    return await BingoPlayer_fetch(BingoPlayer_url + '/models/BingoPlayer/getCard', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.BingoPlayer.getNbrPlayers = async (data) => {
    return await BingoPlayer_fetch(BingoPlayer_url + '/models/BingoPlayer/getNbrPlayers', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.BingoPlayer.getPlayers = async (data) => {
    return await BingoPlayer_fetch(BingoPlayer_url + '/models/BingoPlayer/getPlayers', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.BingoPlayer.getListAllPlayers = async (data) => {
    return await BingoPlayer_fetch(BingoPlayer_url + '/models/BingoPlayer/getListAllPlayers', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var PeupleAi_url = 'http://PeupleAi-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.PeupleAi = {};

const PeupleAi_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.PeupleAi.create = async (model) => {
    return await PeupleAi_fetch(PeupleAi_url + '/models/PeupleAi', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.PeupleAi.getAll = async () => {
    return await PeupleAi_fetch(PeupleAi_url + '/models/PeupleAi');
};

sdk.models.PeupleAi.getOne = async (id) => {
    return await PeupleAi_fetch(PeupleAi_url + '/models/PeupleAi/' + id);
};

sdk.models.PeupleAi.update = async (id, model) => {
    return await PeupleAi_fetch(PeupleAi_url + '/models/PeupleAi/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.PeupleAi.delete = async (id) => {
    return await PeupleAi_fetch(PeupleAi_url + '/models/PeupleAi/' + id, {
        method: 'DELETE'
    });
};

sdk.models.PeupleAi.doCamille = async (data) => {
    return await PeupleAi_fetch(PeupleAi_url + '/models/PeupleAi/doCamille', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.PeupleAi.doCamilleMorning = async (data) => {
    return await PeupleAi_fetch(PeupleAi_url + '/models/PeupleAi/doCamilleMorning', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.PeupleAi.doCamilleApresMidi = async (data) => {
    return await PeupleAi_fetch(PeupleAi_url + '/models/PeupleAi/doCamilleApresMidi', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.PeupleAi.doCamilleMorningPost = async (data) => {
    return await PeupleAi_fetch(PeupleAi_url + '/models/PeupleAi/doCamilleMorningPost', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var ShopCartItem_url = 'http://ShopCartItem-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.ShopCartItem = {};

const ShopCartItem_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.ShopCartItem.create = async (model) => {
    return await ShopCartItem_fetch(ShopCartItem_url + '/models/ShopCartItem', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.ShopCartItem.getAll = async () => {
    return await ShopCartItem_fetch(ShopCartItem_url + '/models/ShopCartItem');
};

sdk.models.ShopCartItem.getOne = async (id) => {
    return await ShopCartItem_fetch(ShopCartItem_url + '/models/ShopCartItem/' + id);
};

sdk.models.ShopCartItem.update = async (id, model) => {
    return await ShopCartItem_fetch(ShopCartItem_url + '/models/ShopCartItem/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.ShopCartItem.delete = async (id) => {
    return await ShopCartItem_fetch(ShopCartItem_url + '/models/ShopCartItem/' + id, {
        method: 'DELETE'
    });
};

sdk.models.ShopCartItem.getCartItem = async (data) => {
    return await ShopCartItem_fetch(ShopCartItem_url + '/models/ShopCartItem/getCartItem', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.ShopCartItem.getUserItems = async (data) => {
    return await ShopCartItem_fetch(ShopCartItem_url + '/models/ShopCartItem/getUserItems', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.ShopCartItem.deleteItem = async (data) => {
    return await ShopCartItem_fetch(ShopCartItem_url + '/models/ShopCartItem/deleteItem', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.ShopCartItem.getShippingCost = async (data) => {
    return await ShopCartItem_fetch(ShopCartItem_url + '/models/ShopCartItem/getShippingCost', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.ShopCartItem.createPaymentIntent = async (data) => {
    return await ShopCartItem_fetch(ShopCartItem_url + '/models/ShopCartItem/createPaymentIntent', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.ShopCartItem.initModel = async (data) => {
    return await ShopCartItem_fetch(ShopCartItem_url + '/models/ShopCartItem/initModel', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.ShopCartItem.paymentMade = async (data) => {
    return await ShopCartItem_fetch(ShopCartItem_url + '/models/ShopCartItem/paymentMade', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var UserAudience_url = 'http://UserAudience-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.UserAudience = {};

const UserAudience_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.UserAudience.create = async (model) => {
    return await UserAudience_fetch(UserAudience_url + '/models/UserAudience', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.UserAudience.getAll = async () => {
    return await UserAudience_fetch(UserAudience_url + '/models/UserAudience');
};

sdk.models.UserAudience.getOne = async (id) => {
    return await UserAudience_fetch(UserAudience_url + '/models/UserAudience/' + id);
};

sdk.models.UserAudience.update = async (id, model) => {
    return await UserAudience_fetch(UserAudience_url + '/models/UserAudience/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.UserAudience.delete = async (id) => {
    return await UserAudience_fetch(UserAudience_url + '/models/UserAudience/' + id, {
        method: 'DELETE'
    });
};

sdk.models.UserAudience.doUser = async (data) => {
    return await UserAudience_fetch(UserAudience_url + '/models/UserAudience/doUser', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.UserAudience.getAudiences = async (data) => {
    return await UserAudience_fetch(UserAudience_url + '/models/UserAudience/getAudiences', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.UserAudience.cronDoUser = async (data) => {
    return await UserAudience_fetch(UserAudience_url + '/models/UserAudience/cronDoUser', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.UserAudience.getUserAudience = async (data) => {
    return await UserAudience_fetch(UserAudience_url + '/models/UserAudience/getUserAudience', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.UserAudience.addAudience = async (data) => {
    return await UserAudience_fetch(UserAudience_url + '/models/UserAudience/addAudience', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.UserAudience.getIntelAudience = async (data) => {
    return await UserAudience_fetch(UserAudience_url + '/models/UserAudience/getIntelAudience', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.UserAudience.redoAll = async (data) => {
    return await UserAudience_fetch(UserAudience_url + '/models/UserAudience/redoAll', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var StorBarcode_url = 'http://StorBarcode-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.StorBarcode = {};

const StorBarcode_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.StorBarcode.create = async (model) => {
    return await StorBarcode_fetch(StorBarcode_url + '/models/StorBarcode', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.StorBarcode.getAll = async () => {
    return await StorBarcode_fetch(StorBarcode_url + '/models/StorBarcode');
};

sdk.models.StorBarcode.getOne = async (id) => {
    return await StorBarcode_fetch(StorBarcode_url + '/models/StorBarcode/' + id);
};

sdk.models.StorBarcode.update = async (id, model) => {
    return await StorBarcode_fetch(StorBarcode_url + '/models/StorBarcode/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.StorBarcode.delete = async (id) => {
    return await StorBarcode_fetch(StorBarcode_url + '/models/StorBarcode/' + id, {
        method: 'DELETE'
    });
};

sdk.models.StorBarcode.getProduct = async (data) => {
    return await StorBarcode_fetch(StorBarcode_url + '/models/StorBarcode/getProduct', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var ImageImpot_url = 'http://ImageImpot-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.ImageImpot = {};

const ImageImpot_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.ImageImpot.create = async (model) => {
    return await ImageImpot_fetch(ImageImpot_url + '/models/ImageImpot', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.ImageImpot.getAll = async () => {
    return await ImageImpot_fetch(ImageImpot_url + '/models/ImageImpot');
};

sdk.models.ImageImpot.getOne = async (id) => {
    return await ImageImpot_fetch(ImageImpot_url + '/models/ImageImpot/' + id);
};

sdk.models.ImageImpot.update = async (id, model) => {
    return await ImageImpot_fetch(ImageImpot_url + '/models/ImageImpot/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.ImageImpot.delete = async (id) => {
    return await ImageImpot_fetch(ImageImpot_url + '/models/ImageImpot/' + id, {
        method: 'DELETE'
    });
};

sdk.models.ImageImpot.getImages = async (data) => {
    return await ImageImpot_fetch(ImageImpot_url + '/models/ImageImpot/getImages', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var InteracPayment_url = 'http://InteracPayment-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.InteracPayment = {};

const InteracPayment_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.InteracPayment.create = async (model) => {
    return await InteracPayment_fetch(InteracPayment_url + '/models/InteracPayment', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.InteracPayment.getAll = async () => {
    return await InteracPayment_fetch(InteracPayment_url + '/models/InteracPayment');
};

sdk.models.InteracPayment.getOne = async (id) => {
    return await InteracPayment_fetch(InteracPayment_url + '/models/InteracPayment/' + id);
};

sdk.models.InteracPayment.update = async (id, model) => {
    return await InteracPayment_fetch(InteracPayment_url + '/models/InteracPayment/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.InteracPayment.delete = async (id) => {
    return await InteracPayment_fetch(InteracPayment_url + '/models/InteracPayment/' + id, {
        method: 'DELETE'
    });
};
var FbPage_url = 'http://FbPage-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.FbPage = {};

const FbPage_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.FbPage.create = async (model) => {
    return await FbPage_fetch(FbPage_url + '/models/FbPage', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.FbPage.getAll = async () => {
    return await FbPage_fetch(FbPage_url + '/models/FbPage');
};

sdk.models.FbPage.getOne = async (id) => {
    return await FbPage_fetch(FbPage_url + '/models/FbPage/' + id);
};

sdk.models.FbPage.update = async (id, model) => {
    return await FbPage_fetch(FbPage_url + '/models/FbPage/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.FbPage.delete = async (id) => {
    return await FbPage_fetch(FbPage_url + '/models/FbPage/' + id, {
        method: 'DELETE'
    });
};

sdk.models.FbPage.timer = async (data) => {
    return await FbPage_fetch(FbPage_url + '/models/FbPage/timer', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.FbPage.onUpdate = async (data) => {
    return await FbPage_fetch(FbPage_url + '/models/FbPage/onUpdate', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.FbPage.getFromUrl = async (data) => {
    return await FbPage_fetch(FbPage_url + '/models/FbPage/getFromUrl', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var VirtualJobUser_url = 'http://VirtualJobUser-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.VirtualJobUser = {};

const VirtualJobUser_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.VirtualJobUser.create = async (model) => {
    return await VirtualJobUser_fetch(VirtualJobUser_url + '/models/VirtualJobUser', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.VirtualJobUser.getAll = async () => {
    return await VirtualJobUser_fetch(VirtualJobUser_url + '/models/VirtualJobUser');
};

sdk.models.VirtualJobUser.getOne = async (id) => {
    return await VirtualJobUser_fetch(VirtualJobUser_url + '/models/VirtualJobUser/' + id);
};

sdk.models.VirtualJobUser.update = async (id, model) => {
    return await VirtualJobUser_fetch(VirtualJobUser_url + '/models/VirtualJobUser/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.VirtualJobUser.delete = async (id) => {
    return await VirtualJobUser_fetch(VirtualJobUser_url + '/models/VirtualJobUser/' + id, {
        method: 'DELETE'
    });
};

sdk.models.VirtualJobUser.updateUser = async (data) => {
    return await VirtualJobUser_fetch(VirtualJobUser_url + '/models/VirtualJobUser/updateUser', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.VirtualJobUser.getMine = async (data) => {
    return await VirtualJobUser_fetch(VirtualJobUser_url + '/models/VirtualJobUser/getMine', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.VirtualJobUser.getListForHiring = async (data) => {
    return await VirtualJobUser_fetch(VirtualJobUser_url + '/models/VirtualJobUser/getListForHiring', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.VirtualJobUser.hire = async (data) => {
    return await VirtualJobUser_fetch(VirtualJobUser_url + '/models/VirtualJobUser/hire', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.VirtualJobUser.getWorkers = async (data) => {
    return await VirtualJobUser_fetch(VirtualJobUser_url + '/models/VirtualJobUser/getWorkers', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var ChatGpt_url = 'http://ChatGpt-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.ChatGpt = {};

const ChatGpt_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.ChatGpt.create = async (model) => {
    return await ChatGpt_fetch(ChatGpt_url + '/models/ChatGpt', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.ChatGpt.getAll = async () => {
    return await ChatGpt_fetch(ChatGpt_url + '/models/ChatGpt');
};

sdk.models.ChatGpt.getOne = async (id) => {
    return await ChatGpt_fetch(ChatGpt_url + '/models/ChatGpt/' + id);
};

sdk.models.ChatGpt.update = async (id, model) => {
    return await ChatGpt_fetch(ChatGpt_url + '/models/ChatGpt/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.ChatGpt.delete = async (id) => {
    return await ChatGpt_fetch(ChatGpt_url + '/models/ChatGpt/' + id, {
        method: 'DELETE'
    });
};

sdk.models.ChatGpt.initModel = async (data) => {
    return await ChatGpt_fetch(ChatGpt_url + '/models/ChatGpt/initModel', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.ChatGpt.newCrmEmail = async (data) => {
    return await ChatGpt_fetch(ChatGpt_url + '/models/ChatGpt/newCrmEmail', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.ChatGpt.createCrmEmail = async (data) => {
    return await ChatGpt_fetch(ChatGpt_url + '/models/ChatGpt/createCrmEmail', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.ChatGpt.ask = async (data) => {
    return await ChatGpt_fetch(ChatGpt_url + '/models/ChatGpt/ask', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.ChatGpt.getModels = async (data) => {
    return await ChatGpt_fetch(ChatGpt_url + '/models/ChatGpt/getModels', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var PageUsers_url = 'http://PageUsers-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.PageUsers = {};

const PageUsers_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.PageUsers.create = async (model) => {
    return await PageUsers_fetch(PageUsers_url + '/models/PageUsers', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.PageUsers.getAll = async () => {
    return await PageUsers_fetch(PageUsers_url + '/models/PageUsers');
};

sdk.models.PageUsers.getOne = async (id) => {
    return await PageUsers_fetch(PageUsers_url + '/models/PageUsers/' + id);
};

sdk.models.PageUsers.update = async (id, model) => {
    return await PageUsers_fetch(PageUsers_url + '/models/PageUsers/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.PageUsers.delete = async (id) => {
    return await PageUsers_fetch(PageUsers_url + '/models/PageUsers/' + id, {
        method: 'DELETE'
    });
};

sdk.models.PageUsers.createPageUser = async (data) => {
    return await PageUsers_fetch(PageUsers_url + '/models/PageUsers/createPageUser', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.PageUsers.deletePageUser = async (data) => {
    return await PageUsers_fetch(PageUsers_url + '/models/PageUsers/deletePageUser', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.PageUsers.getPageUsers = async (data) => {
    return await PageUsers_fetch(PageUsers_url + '/models/PageUsers/getPageUsers', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.PageUsers.searchUser = async (data) => {
    return await PageUsers_fetch(PageUsers_url + '/models/PageUsers/searchUser', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var VirtualAccount_url = 'http://VirtualAccount-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.VirtualAccount = {};

const VirtualAccount_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.VirtualAccount.create = async (model) => {
    return await VirtualAccount_fetch(VirtualAccount_url + '/models/VirtualAccount', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.VirtualAccount.getAll = async () => {
    return await VirtualAccount_fetch(VirtualAccount_url + '/models/VirtualAccount');
};

sdk.models.VirtualAccount.getOne = async (id) => {
    return await VirtualAccount_fetch(VirtualAccount_url + '/models/VirtualAccount/' + id);
};

sdk.models.VirtualAccount.update = async (id, model) => {
    return await VirtualAccount_fetch(VirtualAccount_url + '/models/VirtualAccount/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.VirtualAccount.delete = async (id) => {
    return await VirtualAccount_fetch(VirtualAccount_url + '/models/VirtualAccount/' + id, {
        method: 'DELETE'
    });
};

sdk.models.VirtualAccount.getAccounts = async (data) => {
    return await VirtualAccount_fetch(VirtualAccount_url + '/models/VirtualAccount/getAccounts', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.VirtualAccount.timer = async (data) => {
    return await VirtualAccount_fetch(VirtualAccount_url + '/models/VirtualAccount/timer', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.VirtualAccount.getAccount = async (data) => {
    return await VirtualAccount_fetch(VirtualAccount_url + '/models/VirtualAccount/getAccount', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.VirtualAccount.getMines = async (data) => {
    return await VirtualAccount_fetch(VirtualAccount_url + '/models/VirtualAccount/getMines', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var FbGroupAccount_url = 'http://FbGroupAccount-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.FbGroupAccount = {};

const FbGroupAccount_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.FbGroupAccount.create = async (model) => {
    return await FbGroupAccount_fetch(FbGroupAccount_url + '/models/FbGroupAccount', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.FbGroupAccount.getAll = async () => {
    return await FbGroupAccount_fetch(FbGroupAccount_url + '/models/FbGroupAccount');
};

sdk.models.FbGroupAccount.getOne = async (id) => {
    return await FbGroupAccount_fetch(FbGroupAccount_url + '/models/FbGroupAccount/' + id);
};

sdk.models.FbGroupAccount.update = async (id, model) => {
    return await FbGroupAccount_fetch(FbGroupAccount_url + '/models/FbGroupAccount/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.FbGroupAccount.delete = async (id) => {
    return await FbGroupAccount_fetch(FbGroupAccount_url + '/models/FbGroupAccount/' + id, {
        method: 'DELETE'
    });
};

sdk.models.FbGroupAccount.getUserGroups = async (data) => {
    return await FbGroupAccount_fetch(FbGroupAccount_url + '/models/FbGroupAccount/getUserGroups', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.FbGroupAccount.cancel = async (data) => {
    return await FbGroupAccount_fetch(FbGroupAccount_url + '/models/FbGroupAccount/cancel', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.FbGroupAccount.getWorking = async (data) => {
    return await FbGroupAccount_fetch(FbGroupAccount_url + '/models/FbGroupAccount/getWorking', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.FbGroupAccount.getWorkingDetailed = async (data) => {
    return await FbGroupAccount_fetch(FbGroupAccount_url + '/models/FbGroupAccount/getWorkingDetailed', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.FbGroupAccount.sendPost = async (data) => {
    return await FbGroupAccount_fetch(FbGroupAccount_url + '/models/FbGroupAccount/sendPost', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.FbGroupAccount.getAllUserGroups = async (data) => {
    return await FbGroupAccount_fetch(FbGroupAccount_url + '/models/FbGroupAccount/getAllUserGroups', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var WebDomain_url = 'http://WebDomain-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.WebDomain = {};

const WebDomain_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.WebDomain.create = async (model) => {
    return await WebDomain_fetch(WebDomain_url + '/models/WebDomain', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.WebDomain.getAll = async () => {
    return await WebDomain_fetch(WebDomain_url + '/models/WebDomain');
};

sdk.models.WebDomain.getOne = async (id) => {
    return await WebDomain_fetch(WebDomain_url + '/models/WebDomain/' + id);
};

sdk.models.WebDomain.update = async (id, model) => {
    return await WebDomain_fetch(WebDomain_url + '/models/WebDomain/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.WebDomain.delete = async (id) => {
    return await WebDomain_fetch(WebDomain_url + '/models/WebDomain/' + id, {
        method: 'DELETE'
    });
};

sdk.models.WebDomain.getDomain = async (data) => {
    return await WebDomain_fetch(WebDomain_url + '/models/WebDomain/getDomain', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.WebDomain.search = async (data) => {
    return await WebDomain_fetch(WebDomain_url + '/models/WebDomain/search', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var ClaudeAi_url = 'http://ClaudeAi-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.ClaudeAi = {};

const ClaudeAi_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.ClaudeAi.create = async (model) => {
    return await ClaudeAi_fetch(ClaudeAi_url + '/models/ClaudeAi', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.ClaudeAi.getAll = async () => {
    return await ClaudeAi_fetch(ClaudeAi_url + '/models/ClaudeAi');
};

sdk.models.ClaudeAi.getOne = async (id) => {
    return await ClaudeAi_fetch(ClaudeAi_url + '/models/ClaudeAi/' + id);
};

sdk.models.ClaudeAi.update = async (id, model) => {
    return await ClaudeAi_fetch(ClaudeAi_url + '/models/ClaudeAi/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.ClaudeAi.delete = async (id) => {
    return await ClaudeAi_fetch(ClaudeAi_url + '/models/ClaudeAi/' + id, {
        method: 'DELETE'
    });
};

sdk.models.ClaudeAi.ask = async (data) => {
    return await ClaudeAi_fetch(ClaudeAi_url + '/models/ClaudeAi/ask', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.ClaudeAi.getModels = async (data) => {
    return await ClaudeAi_fetch(ClaudeAi_url + '/models/ClaudeAi/getModels', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var WebEmail_url = 'http://WebEmail-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.WebEmail = {};

const WebEmail_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.WebEmail.create = async (model) => {
    return await WebEmail_fetch(WebEmail_url + '/models/WebEmail', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.WebEmail.getAll = async () => {
    return await WebEmail_fetch(WebEmail_url + '/models/WebEmail');
};

sdk.models.WebEmail.getOne = async (id) => {
    return await WebEmail_fetch(WebEmail_url + '/models/WebEmail/' + id);
};

sdk.models.WebEmail.update = async (id, model) => {
    return await WebEmail_fetch(WebEmail_url + '/models/WebEmail/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.WebEmail.delete = async (id) => {
    return await WebEmail_fetch(WebEmail_url + '/models/WebEmail/' + id, {
        method: 'DELETE'
    });
};

sdk.models.WebEmail.getEmailsFromDomains = async (data) => {
    return await WebEmail_fetch(WebEmail_url + '/models/WebEmail/getEmailsFromDomains', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var MarketingEmail_url = 'http://MarketingEmail-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.MarketingEmail = {};

const MarketingEmail_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.MarketingEmail.create = async (model) => {
    return await MarketingEmail_fetch(MarketingEmail_url + '/models/MarketingEmail', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.MarketingEmail.getAll = async () => {
    return await MarketingEmail_fetch(MarketingEmail_url + '/models/MarketingEmail');
};

sdk.models.MarketingEmail.getOne = async (id) => {
    return await MarketingEmail_fetch(MarketingEmail_url + '/models/MarketingEmail/' + id);
};

sdk.models.MarketingEmail.update = async (id, model) => {
    return await MarketingEmail_fetch(MarketingEmail_url + '/models/MarketingEmail/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.MarketingEmail.delete = async (id) => {
    return await MarketingEmail_fetch(MarketingEmail_url + '/models/MarketingEmail/' + id, {
        method: 'DELETE'
    });
};

sdk.models.MarketingEmail.onUpdate = async (data) => {
    return await MarketingEmail_fetch(MarketingEmail_url + '/models/MarketingEmail/onUpdate', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.MarketingEmail.getCampaign = async (data) => {
    return await MarketingEmail_fetch(MarketingEmail_url + '/models/MarketingEmail/getCampaign', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.MarketingEmail.addEmail = async (data) => {
    return await MarketingEmail_fetch(MarketingEmail_url + '/models/MarketingEmail/addEmail', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var CrmEmail_url = 'http://CrmEmail-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.CrmEmail = {};

const CrmEmail_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.CrmEmail.create = async (model) => {
    return await CrmEmail_fetch(CrmEmail_url + '/models/CrmEmail', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.CrmEmail.getAll = async () => {
    return await CrmEmail_fetch(CrmEmail_url + '/models/CrmEmail');
};

sdk.models.CrmEmail.getOne = async (id) => {
    return await CrmEmail_fetch(CrmEmail_url + '/models/CrmEmail/' + id);
};

sdk.models.CrmEmail.update = async (id, model) => {
    return await CrmEmail_fetch(CrmEmail_url + '/models/CrmEmail/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.CrmEmail.delete = async (id) => {
    return await CrmEmail_fetch(CrmEmail_url + '/models/CrmEmail/' + id, {
        method: 'DELETE'
    });
};

sdk.models.CrmEmail.getEmails = async (data) => {
    return await CrmEmail_fetch(CrmEmail_url + '/models/CrmEmail/getEmails', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.CrmEmail.sendEmail = async (data) => {
    return await CrmEmail_fetch(CrmEmail_url + '/models/CrmEmail/sendEmail', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.CrmEmail.timer = async (data) => {
    return await CrmEmail_fetch(CrmEmail_url + '/models/CrmEmail/timer', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.CrmEmail.getByMessageId = async (data) => {
    return await CrmEmail_fetch(CrmEmail_url + '/models/CrmEmail/getByMessageId', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.CrmEmail.getInbox = async (data) => {
    return await CrmEmail_fetch(CrmEmail_url + '/models/CrmEmail/getInbox', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.CrmEmail.getOutbox = async (data) => {
    return await CrmEmail_fetch(CrmEmail_url + '/models/CrmEmail/getOutbox', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var WebUrl_url = 'http://WebUrl-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.WebUrl = {};

const WebUrl_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.WebUrl.create = async (model) => {
    return await WebUrl_fetch(WebUrl_url + '/models/WebUrl', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.WebUrl.getAll = async () => {
    return await WebUrl_fetch(WebUrl_url + '/models/WebUrl');
};

sdk.models.WebUrl.getOne = async (id) => {
    return await WebUrl_fetch(WebUrl_url + '/models/WebUrl/' + id);
};

sdk.models.WebUrl.update = async (id, model) => {
    return await WebUrl_fetch(WebUrl_url + '/models/WebUrl/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.WebUrl.delete = async (id) => {
    return await WebUrl_fetch(WebUrl_url + '/models/WebUrl/' + id, {
        method: 'DELETE'
    });
};

sdk.models.WebUrl.addUrl = async (data) => {
    return await WebUrl_fetch(WebUrl_url + '/models/WebUrl/addUrl', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.WebUrl.findByUrl = async (data) => {
    return await WebUrl_fetch(WebUrl_url + '/models/WebUrl/findByUrl', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var CrmContact_url = 'http://CrmContact-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.CrmContact = {};

const CrmContact_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.CrmContact.create = async (model) => {
    return await CrmContact_fetch(CrmContact_url + '/models/CrmContact', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.CrmContact.getAll = async () => {
    return await CrmContact_fetch(CrmContact_url + '/models/CrmContact');
};

sdk.models.CrmContact.getOne = async (id) => {
    return await CrmContact_fetch(CrmContact_url + '/models/CrmContact/' + id);
};

sdk.models.CrmContact.update = async (id, model) => {
    return await CrmContact_fetch(CrmContact_url + '/models/CrmContact/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.CrmContact.delete = async (id) => {
    return await CrmContact_fetch(CrmContact_url + '/models/CrmContact/' + id, {
        method: 'DELETE'
    });
};

sdk.models.CrmContact.findByEmail = async (data) => {
    return await CrmContact_fetch(CrmContact_url + '/models/CrmContact/findByEmail', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var AiCommand_url = 'http://AiCommand-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.AiCommand = {};

const AiCommand_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.AiCommand.create = async (model) => {
    return await AiCommand_fetch(AiCommand_url + '/models/AiCommand', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.AiCommand.getAll = async () => {
    return await AiCommand_fetch(AiCommand_url + '/models/AiCommand');
};

sdk.models.AiCommand.getOne = async (id) => {
    return await AiCommand_fetch(AiCommand_url + '/models/AiCommand/' + id);
};

sdk.models.AiCommand.update = async (id, model) => {
    return await AiCommand_fetch(AiCommand_url + '/models/AiCommand/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.AiCommand.delete = async (id) => {
    return await AiCommand_fetch(AiCommand_url + '/models/AiCommand/' + id, {
        method: 'DELETE'
    });
};

sdk.models.AiCommand.getAgentCommands = async (data) => {
    return await AiCommand_fetch(AiCommand_url + '/models/AiCommand/getAgentCommands', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var AdsZone_url = 'http://AdsZone-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.AdsZone = {};

const AdsZone_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.AdsZone.create = async (model) => {
    return await AdsZone_fetch(AdsZone_url + '/models/AdsZone', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.AdsZone.getAll = async () => {
    return await AdsZone_fetch(AdsZone_url + '/models/AdsZone');
};

sdk.models.AdsZone.getOne = async (id) => {
    return await AdsZone_fetch(AdsZone_url + '/models/AdsZone/' + id);
};

sdk.models.AdsZone.update = async (id, model) => {
    return await AdsZone_fetch(AdsZone_url + '/models/AdsZone/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.AdsZone.delete = async (id) => {
    return await AdsZone_fetch(AdsZone_url + '/models/AdsZone/' + id, {
        method: 'DELETE'
    });
};

sdk.models.AdsZone.getZone = async (data) => {
    return await AdsZone_fetch(AdsZone_url + '/models/AdsZone/getZone', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var AiAgent_url = 'http://AiAgent-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.AiAgent = {};

const AiAgent_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.AiAgent.create = async (model) => {
    return await AiAgent_fetch(AiAgent_url + '/models/AiAgent', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.AiAgent.getAll = async () => {
    return await AiAgent_fetch(AiAgent_url + '/models/AiAgent');
};

sdk.models.AiAgent.getOne = async (id) => {
    return await AiAgent_fetch(AiAgent_url + '/models/AiAgent/' + id);
};

sdk.models.AiAgent.update = async (id, model) => {
    return await AiAgent_fetch(AiAgent_url + '/models/AiAgent/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.AiAgent.delete = async (id) => {
    return await AiAgent_fetch(AiAgent_url + '/models/AiAgent/' + id, {
        method: 'DELETE'
    });
};

sdk.models.AiAgent.updateAgentTimer = async (data) => {
    return await AiAgent_fetch(AiAgent_url + '/models/AiAgent/updateAgentTimer', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.AiAgent.askAgent = async (data) => {
    return await AiAgent_fetch(AiAgent_url + '/models/AiAgent/askAgent', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.AiAgent.askCoder = async (data) => {
    return await AiAgent_fetch(AiAgent_url + '/models/AiAgent/askCoder', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.AiAgent.testTimer = async (data) => {
    return await AiAgent_fetch(AiAgent_url + '/models/AiAgent/testTimer', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.AiAgent.getAgent = async (data) => {
    return await AiAgent_fetch(AiAgent_url + '/models/AiAgent/getAgent', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.AiAgent.newCrmEmail = async (data) => {
    return await AiAgent_fetch(AiAgent_url + '/models/AiAgent/newCrmEmail', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var Queue_url = 'http://Queue-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.Queue = {};

const Queue_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.Queue.create = async (model) => {
    return await Queue_fetch(Queue_url + '/models/Queue', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.Queue.getAll = async () => {
    return await Queue_fetch(Queue_url + '/models/Queue');
};

sdk.models.Queue.getOne = async (id) => {
    return await Queue_fetch(Queue_url + '/models/Queue/' + id);
};

sdk.models.Queue.update = async (id, model) => {
    return await Queue_fetch(Queue_url + '/models/Queue/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.Queue.delete = async (id) => {
    return await Queue_fetch(Queue_url + '/models/Queue/' + id, {
        method: 'DELETE'
    });
};

sdk.models.Queue.initModel = async (data) => {
    return await Queue_fetch(Queue_url + '/models/Queue/initModel', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.Queue.onUpdate = async (data) => {
    return await Queue_fetch(Queue_url + '/models/Queue/onUpdate', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.Queue.sendMessage = async (data) => {
    return await Queue_fetch(Queue_url + '/models/Queue/sendMessage', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var WebSocket_url = 'http://WebSocket-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.WebSocket = {};

const WebSocket_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.WebSocket.create = async (model) => {
    return await WebSocket_fetch(WebSocket_url + '/models/WebSocket', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.WebSocket.getAll = async () => {
    return await WebSocket_fetch(WebSocket_url + '/models/WebSocket');
};

sdk.models.WebSocket.getOne = async (id) => {
    return await WebSocket_fetch(WebSocket_url + '/models/WebSocket/' + id);
};

sdk.models.WebSocket.update = async (id, model) => {
    return await WebSocket_fetch(WebSocket_url + '/models/WebSocket/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.WebSocket.delete = async (id) => {
    return await WebSocket_fetch(WebSocket_url + '/models/WebSocket/' + id, {
        method: 'DELETE'
    });
};
var CrmCompany_url = 'http://CrmCompany-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.CrmCompany = {};

const CrmCompany_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.CrmCompany.create = async (model) => {
    return await CrmCompany_fetch(CrmCompany_url + '/models/CrmCompany', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.CrmCompany.getAll = async () => {
    return await CrmCompany_fetch(CrmCompany_url + '/models/CrmCompany');
};

sdk.models.CrmCompany.getOne = async (id) => {
    return await CrmCompany_fetch(CrmCompany_url + '/models/CrmCompany/' + id);
};

sdk.models.CrmCompany.update = async (id, model) => {
    return await CrmCompany_fetch(CrmCompany_url + '/models/CrmCompany/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.CrmCompany.delete = async (id) => {
    return await CrmCompany_fetch(CrmCompany_url + '/models/CrmCompany/' + id, {
        method: 'DELETE'
    });
};

sdk.models.CrmCompany.findNeq = async (data) => {
    return await CrmCompany_fetch(CrmCompany_url + '/models/CrmCompany/findNeq', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var AiTask_url = 'http://AiTask-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.AiTask = {};

const AiTask_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.AiTask.create = async (model) => {
    return await AiTask_fetch(AiTask_url + '/models/AiTask', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.AiTask.getAll = async () => {
    return await AiTask_fetch(AiTask_url + '/models/AiTask');
};

sdk.models.AiTask.getOne = async (id) => {
    return await AiTask_fetch(AiTask_url + '/models/AiTask/' + id);
};

sdk.models.AiTask.update = async (id, model) => {
    return await AiTask_fetch(AiTask_url + '/models/AiTask/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.AiTask.delete = async (id) => {
    return await AiTask_fetch(AiTask_url + '/models/AiTask/' + id, {
        method: 'DELETE'
    });
};

sdk.models.AiTask.onCreate = async (data) => {
    return await AiTask_fetch(AiTask_url + '/models/AiTask/onCreate', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.AiTask.initModel = async (data) => {
    return await AiTask_fetch(AiTask_url + '/models/AiTask/initModel', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var CrmEmailAccount_url = 'http://CrmEmailAccount-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.CrmEmailAccount = {};

const CrmEmailAccount_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.CrmEmailAccount.create = async (model) => {
    return await CrmEmailAccount_fetch(CrmEmailAccount_url + '/models/CrmEmailAccount', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.CrmEmailAccount.getAll = async () => {
    return await CrmEmailAccount_fetch(CrmEmailAccount_url + '/models/CrmEmailAccount');
};

sdk.models.CrmEmailAccount.getOne = async (id) => {
    return await CrmEmailAccount_fetch(CrmEmailAccount_url + '/models/CrmEmailAccount/' + id);
};

sdk.models.CrmEmailAccount.update = async (id, model) => {
    return await CrmEmailAccount_fetch(CrmEmailAccount_url + '/models/CrmEmailAccount/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.CrmEmailAccount.delete = async (id) => {
    return await CrmEmailAccount_fetch(CrmEmailAccount_url + '/models/CrmEmailAccount/' + id, {
        method: 'DELETE'
    });
};

sdk.models.CrmEmailAccount.getMine = async (data) => {
    return await CrmEmailAccount_fetch(CrmEmailAccount_url + '/models/CrmEmailAccount/getMine', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.CrmEmailAccount.getByEmail = async (data) => {
    return await CrmEmailAccount_fetch(CrmEmailAccount_url + '/models/CrmEmailAccount/getByEmail', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.CrmEmailAccount.getByUser = async (data) => {
    return await CrmEmailAccount_fetch(CrmEmailAccount_url + '/models/CrmEmailAccount/getByUser', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var MarketingEmailRecipient_url = 'http://MarketingEmailRecipient-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.MarketingEmailRecipient = {};

const MarketingEmailRecipient_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.MarketingEmailRecipient.create = async (model) => {
    return await MarketingEmailRecipient_fetch(MarketingEmailRecipient_url + '/models/MarketingEmailRecipient', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.MarketingEmailRecipient.getAll = async () => {
    return await MarketingEmailRecipient_fetch(MarketingEmailRecipient_url + '/models/MarketingEmailRecipient');
};

sdk.models.MarketingEmailRecipient.getOne = async (id) => {
    return await MarketingEmailRecipient_fetch(MarketingEmailRecipient_url + '/models/MarketingEmailRecipient/' + id);
};

sdk.models.MarketingEmailRecipient.update = async (id, model) => {
    return await MarketingEmailRecipient_fetch(MarketingEmailRecipient_url + '/models/MarketingEmailRecipient/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.MarketingEmailRecipient.delete = async (id) => {
    return await MarketingEmailRecipient_fetch(MarketingEmailRecipient_url + '/models/MarketingEmailRecipient/' + id, {
        method: 'DELETE'
    });
};

sdk.models.MarketingEmailRecipient.onCreate = async (data) => {
    return await MarketingEmailRecipient_fetch(MarketingEmailRecipient_url + '/models/MarketingEmailRecipient/onCreate', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.MarketingEmailRecipient.getList = async (data) => {
    return await MarketingEmailRecipient_fetch(MarketingEmailRecipient_url + '/models/MarketingEmailRecipient/getList', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.MarketingEmailRecipient.addEmail = async (data) => {
    return await MarketingEmailRecipient_fetch(MarketingEmailRecipient_url + '/models/MarketingEmailRecipient/addEmail', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var Enom_url = 'http://Enom-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.Enom = {};

const Enom_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.Enom.create = async (model) => {
    return await Enom_fetch(Enom_url + '/models/Enom', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.Enom.getAll = async () => {
    return await Enom_fetch(Enom_url + '/models/Enom');
};

sdk.models.Enom.getOne = async (id) => {
    return await Enom_fetch(Enom_url + '/models/Enom/' + id);
};

sdk.models.Enom.update = async (id, model) => {
    return await Enom_fetch(Enom_url + '/models/Enom/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.Enom.delete = async (id) => {
    return await Enom_fetch(Enom_url + '/models/Enom/' + id, {
        method: 'DELETE'
    });
};

sdk.models.Enom.initModel = async (data) => {
    return await Enom_fetch(Enom_url + '/models/Enom/initModel', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var CrmEtablissement_url = 'http://CrmEtablissement-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.CrmEtablissement = {};

const CrmEtablissement_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.CrmEtablissement.create = async (model) => {
    return await CrmEtablissement_fetch(CrmEtablissement_url + '/models/CrmEtablissement', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.CrmEtablissement.getAll = async () => {
    return await CrmEtablissement_fetch(CrmEtablissement_url + '/models/CrmEtablissement');
};

sdk.models.CrmEtablissement.getOne = async (id) => {
    return await CrmEtablissement_fetch(CrmEtablissement_url + '/models/CrmEtablissement/' + id);
};

sdk.models.CrmEtablissement.update = async (id, model) => {
    return await CrmEtablissement_fetch(CrmEtablissement_url + '/models/CrmEtablissement/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.CrmEtablissement.delete = async (id) => {
    return await CrmEtablissement_fetch(CrmEtablissement_url + '/models/CrmEtablissement/' + id, {
        method: 'DELETE'
    });
};

sdk.models.CrmEtablissement.search = async (data) => {
    return await CrmEtablissement_fetch(CrmEtablissement_url + '/models/CrmEtablissement/search', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.CrmEtablissement.onUpdate = async (data) => {
    return await CrmEtablissement_fetch(CrmEtablissement_url + '/models/CrmEtablissement/onUpdate', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var audit_sessions_url = 'http://audit-sessions-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.audit_sessions = {};

const audit_sessions_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.audit_sessions.create = async (model) => {
    return await audit_sessions_fetch(audit_sessions_url + '/models/audit_sessions', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.audit_sessions.getAll = async () => {
    return await audit_sessions_fetch(audit_sessions_url + '/models/audit_sessions');
};

sdk.models.audit_sessions.getOne = async (id) => {
    return await audit_sessions_fetch(audit_sessions_url + '/models/audit_sessions/' + id);
};

sdk.models.audit_sessions.update = async (id, model) => {
    return await audit_sessions_fetch(audit_sessions_url + '/models/audit_sessions/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.audit_sessions.delete = async (id) => {
    return await audit_sessions_fetch(audit_sessions_url + '/models/audit_sessions/' + id, {
        method: 'DELETE'
    });
};

sdk.models.audit_sessions.create = async (data) => {
    return await audit_sessions_fetch(audit_sessions_url + '/models/audit_sessions/create', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var audit_page_views_url = 'http://audit-page-views-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.audit_page_views = {};

const audit_page_views_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.audit_page_views.create = async (model) => {
    return await audit_page_views_fetch(audit_page_views_url + '/models/audit_page_views', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.audit_page_views.getAll = async () => {
    return await audit_page_views_fetch(audit_page_views_url + '/models/audit_page_views');
};

sdk.models.audit_page_views.getOne = async (id) => {
    return await audit_page_views_fetch(audit_page_views_url + '/models/audit_page_views/' + id);
};

sdk.models.audit_page_views.update = async (id, model) => {
    return await audit_page_views_fetch(audit_page_views_url + '/models/audit_page_views/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.audit_page_views.delete = async (id) => {
    return await audit_page_views_fetch(audit_page_views_url + '/models/audit_page_views/' + id, {
        method: 'DELETE'
    });
};

sdk.models.audit_page_views.create = async (data) => {
    return await audit_page_views_fetch(audit_page_views_url + '/models/audit_page_views/create', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var audit_user_interactions_url = 'http://audit-user-interactions-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.audit_user_interactions = {};

const audit_user_interactions_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.audit_user_interactions.create = async (model) => {
    return await audit_user_interactions_fetch(audit_user_interactions_url + '/models/audit_user_interactions', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.audit_user_interactions.getAll = async () => {
    return await audit_user_interactions_fetch(audit_user_interactions_url + '/models/audit_user_interactions');
};

sdk.models.audit_user_interactions.getOne = async (id) => {
    return await audit_user_interactions_fetch(audit_user_interactions_url + '/models/audit_user_interactions/' + id);
};

sdk.models.audit_user_interactions.update = async (id, model) => {
    return await audit_user_interactions_fetch(audit_user_interactions_url + '/models/audit_user_interactions/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.audit_user_interactions.delete = async (id) => {
    return await audit_user_interactions_fetch(audit_user_interactions_url + '/models/audit_user_interactions/' + id, {
        method: 'DELETE'
    });
};

sdk.models.audit_user_interactions.create = async (data) => {
    return await audit_user_interactions_fetch(audit_user_interactions_url + '/models/audit_user_interactions/create', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var CrmFollowup_url = 'http://CrmFollowup-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.CrmFollowup = {};

const CrmFollowup_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.CrmFollowup.create = async (model) => {
    return await CrmFollowup_fetch(CrmFollowup_url + '/models/CrmFollowup', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.CrmFollowup.getAll = async () => {
    return await CrmFollowup_fetch(CrmFollowup_url + '/models/CrmFollowup');
};

sdk.models.CrmFollowup.getOne = async (id) => {
    return await CrmFollowup_fetch(CrmFollowup_url + '/models/CrmFollowup/' + id);
};

sdk.models.CrmFollowup.update = async (id, model) => {
    return await CrmFollowup_fetch(CrmFollowup_url + '/models/CrmFollowup/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.CrmFollowup.delete = async (id) => {
    return await CrmFollowup_fetch(CrmFollowup_url + '/models/CrmFollowup/' + id, {
        method: 'DELETE'
    });
};

sdk.models.CrmFollowup.timer = async (data) => {
    return await CrmFollowup_fetch(CrmFollowup_url + '/models/CrmFollowup/timer', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var TaskReview_url = 'http://TaskReview-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.TaskReview = {};

const TaskReview_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.TaskReview.create = async (model) => {
    return await TaskReview_fetch(TaskReview_url + '/models/TaskReview', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.TaskReview.getAll = async () => {
    return await TaskReview_fetch(TaskReview_url + '/models/TaskReview');
};

sdk.models.TaskReview.getOne = async (id) => {
    return await TaskReview_fetch(TaskReview_url + '/models/TaskReview/' + id);
};

sdk.models.TaskReview.update = async (id, model) => {
    return await TaskReview_fetch(TaskReview_url + '/models/TaskReview/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.TaskReview.delete = async (id) => {
    return await TaskReview_fetch(TaskReview_url + '/models/TaskReview/' + id, {
        method: 'DELETE'
    });
};

sdk.models.TaskReview.onCreate = async (data) => {
    return await TaskReview_fetch(TaskReview_url + '/models/TaskReview/onCreate', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.TaskReview.getRated = async (data) => {
    return await TaskReview_fetch(TaskReview_url + '/models/TaskReview/getRated', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var AdBidRequest_url = 'http://AdBidRequest-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.AdBidRequest = {};

const AdBidRequest_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.AdBidRequest.create = async (model) => {
    return await AdBidRequest_fetch(AdBidRequest_url + '/models/AdBidRequest', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.AdBidRequest.getAll = async () => {
    return await AdBidRequest_fetch(AdBidRequest_url + '/models/AdBidRequest');
};

sdk.models.AdBidRequest.getOne = async (id) => {
    return await AdBidRequest_fetch(AdBidRequest_url + '/models/AdBidRequest/' + id);
};

sdk.models.AdBidRequest.update = async (id, model) => {
    return await AdBidRequest_fetch(AdBidRequest_url + '/models/AdBidRequest/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.AdBidRequest.delete = async (id) => {
    return await AdBidRequest_fetch(AdBidRequest_url + '/models/AdBidRequest/' + id, {
        method: 'DELETE'
    });
};

sdk.models.AdBidRequest.initModel = async (data) => {
    return await AdBidRequest_fetch(AdBidRequest_url + '/models/AdBidRequest/initModel', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.AdBidRequest.request = async (data) => {
    return await AdBidRequest_fetch(AdBidRequest_url + '/models/AdBidRequest/request', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

sdk.models.AdBidRequest.winBid = async (data) => {
    return await AdBidRequest_fetch(AdBidRequest_url + '/models/AdBidRequest/winBid', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var RtbImpression_url = 'http://RtbImpression-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.RtbImpression = {};

const RtbImpression_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.RtbImpression.create = async (model) => {
    return await RtbImpression_fetch(RtbImpression_url + '/models/RtbImpression', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.RtbImpression.getAll = async () => {
    return await RtbImpression_fetch(RtbImpression_url + '/models/RtbImpression');
};

sdk.models.RtbImpression.getOne = async (id) => {
    return await RtbImpression_fetch(RtbImpression_url + '/models/RtbImpression/' + id);
};

sdk.models.RtbImpression.update = async (id, model) => {
    return await RtbImpression_fetch(RtbImpression_url + '/models/RtbImpression/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.RtbImpression.delete = async (id) => {
    return await RtbImpression_fetch(RtbImpression_url + '/models/RtbImpression/' + id, {
        method: 'DELETE'
    });
};

sdk.models.RtbImpression.addImp = async (data) => {
    return await RtbImpression_fetch(RtbImpression_url + '/models/RtbImpression/addImp', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var PostsWaiting_url = 'http://PostsWaiting-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.PostsWaiting = {};

const PostsWaiting_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.PostsWaiting.create = async (model) => {
    return await PostsWaiting_fetch(PostsWaiting_url + '/models/PostsWaiting', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.PostsWaiting.getAll = async () => {
    return await PostsWaiting_fetch(PostsWaiting_url + '/models/PostsWaiting');
};

sdk.models.PostsWaiting.getOne = async (id) => {
    return await PostsWaiting_fetch(PostsWaiting_url + '/models/PostsWaiting/' + id);
};

sdk.models.PostsWaiting.update = async (id, model) => {
    return await PostsWaiting_fetch(PostsWaiting_url + '/models/PostsWaiting/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.PostsWaiting.delete = async (id) => {
    return await PostsWaiting_fetch(PostsWaiting_url + '/models/PostsWaiting/' + id, {
        method: 'DELETE'
    });
};

sdk.models.PostsWaiting.timer = async (data) => {
    return await PostsWaiting_fetch(PostsWaiting_url + '/models/PostsWaiting/timer', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
var Jeton_url = 'http://Jeton-prod-svc.models-prod.svc.cluster.local:8080';
sdk.models.Jeton = {};

const Jeton_fetch = async (url, options = {}) => {
    const headers = {
        "liberium-token": "eric986a0d65715f664dd2d9fa0ca1c9d4c88f3bd7358ecab4f136c909f5348ff37ac316f6c38af42a0a4982eced53db",
        "Content-Type": "application/json",
        ...options.headers
    };
    
    try {
        const response = await fetch(url, {
            ...options,
            headers
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { error: errorData };
        }
        
        return await response.json();
    } catch (error) {
        return { error: error.message };
    }
};

sdk.models.Jeton.create = async (model) => {
    return await Jeton_fetch(Jeton_url + '/models/Jeton', {
        method: 'POST',
        body: JSON.stringify(model)
    });
};

sdk.models.Jeton.getAll = async () => {
    return await Jeton_fetch(Jeton_url + '/models/Jeton');
};

sdk.models.Jeton.getOne = async (id) => {
    return await Jeton_fetch(Jeton_url + '/models/Jeton/' + id);
};

sdk.models.Jeton.update = async (id, model) => {
    return await Jeton_fetch(Jeton_url + '/models/Jeton/' + id, {
        method: 'PUT',
        body: JSON.stringify(model)
    });
};

sdk.models.Jeton.delete = async (id) => {
    return await Jeton_fetch(Jeton_url + '/models/Jeton/' + id, {
        method: 'DELETE'
    });
};
sdk.helpers = {};
sdk.helpers.preparePost = async function (body) {
// console.log("Prepare Post body:", body);
var search = {post_id: body.id}
// console.log("search in prepare post:", search);
var likes = await sdkLocal.models.PostsLike.getPostLikes(search);
//console.log("likes found:", likes);
body.nbrLikes = likes.nbrLikes;

var hasLiked = false;
if (typeof body.token !== "undefined" && body.token && likes) {
    likes.likes.forEach(function(like) {
        //console.log("like:", like);
        if (like && like.user_id === body.token.user_id)
            hasLiked = true;
    });
}
body.hasLiked = hasLiked;

const calculateElapsedTime = (timestamp) => {
    const now = Date.now();
    const postTime = new Date(timestamp * 1000);
    const diffInSeconds = Math.floor((now - postTime) / 1000);

    if (diffInSeconds < 60) {
        return `Il y a ${diffInSeconds} seconde${diffInSeconds > 1 ? "s" : ""}`;
    }
    const minutes = Math.floor(diffInSeconds / 60);
    if (minutes < 60) {
        return `Il y a ${minutes} minute${minutes > 1 ? "s" : ""}`;
    }
    const hours = Math.floor(diffInSeconds / 3600);
    if (hours < 24) {
        return `Il y a ${hours} heure${hours > 1 ? "s" : ""}`;
    }
    const days = Math.floor(diffInSeconds / 86400);
    return `Il y a ${days} jour${days > 1 ? "s" : ""}`;
};

body.il_y_a = calculateElapsedTime(body.time);

// Fetch comments for the post
var comments = await sdkLocal.models.SocialComment.getPostComments({post_id: body.id});

// Check if each comment is liked by the current user if token exists
if (typeof body.token !== "undefined" && body.token && comments && comments.length > 0) {
    // Use Promise.all to run all hasLiked checks in parallel for better performance
    const commentWithLikes = await Promise.all(comments.map(async (comment) => {
        try {
            const likeStatus = await sdkLocal.models.SocialCommentLike.hasLiked({
                user_id: body.token.user_id, 
                comment_id: comment.id
            });
            
            // Add hasLiked property to the comment
            return {
                ...comment,
                hasLiked: likeStatus.hasLiked || false
            };
        } catch (error) {
            console.error(`Error checking like status for comment ${comment.id}:`, error);
            // Return the comment without modification if there's an error
            return {
                ...comment,
                hasLiked: false
            };
        }
    }));
    
    body.comments = commentWithLikes;
} else {
    // If no token or no comments, just set the comments as is
    body.comments = [];
}
//console.log("preparedPost:", body);
return body;
};
sdk.helpers.prepareUser = async function (body) {
console.log("Prepare Post body:",body);

var new_user = {}
new_user.user_id = body.user_id;
new_user.username = body.username;
new_user.cover = body.cover;
new_user.first_name = body.first_name;
new_user.last_name = body.last_name;
new_user.avatar = body.avatar;
new_user.relationship_id = body.relationship_id;
new_user.working = body.working;
new_user.working_link = body.working_link;
new_user.about = body.about;
new_user.school = body.school;
new_user.gender = body.gender;
new_user.website = body.website;
new_user.facebook = body.facebook;
new_user.google = body.google;
new_user.twitter = body.twitter;
new_user.linkedin = body.linkedin;
new_user.youtube = body.youtube;
new_user.instagram = body.instagram;
new_user.lastseen = body.lastseen;
new_user.joined = body.joined;

return new_user;
};
module.exports = sdk;
